/* eslint-disable */
"use strict";
exports["28114266"] = validate10;
const schema11 = {"type":"object","properties":{"resource_type":{"type":"string","const":"Cache","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"engine":{"type":"string","description":"The caching engine used (e.g., 'Redis', 'Memcached')."},"node_type":{"type":"string","description":"The instance size for the cache nodes."}},"title":"Cache","anyOf":[{"required":["resource_type"]},{"required":["name"]},{"required":["environment"]},{"required":["install_status"]},{"required":["engine"]},{"required":["node_type"]}],"$id":"28114266"};

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="28114266" */;
let vErrors = null;
let errors = 0;
const _errs1 = errors;
let valid0 = false;
const _errs2 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type === undefined){
const err0 = {instancePath,schemaPath:"#/anyOf/0/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema11.anyOf[0].required,parentSchema:schema11.anyOf[0],data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var _valid0 = _errs2 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/anyOf/1/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema11.anyOf[1].required,parentSchema:schema11.anyOf[1],data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs3 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.environment === undefined){
const err2 = {instancePath,schemaPath:"#/anyOf/2/required",keyword:"required",params:{missingProperty: "environment"},message:"must have required property '"+"environment"+"'",schema:schema11.anyOf[2].required,parentSchema:schema11.anyOf[2],data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs4 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.install_status === undefined){
const err3 = {instancePath,schemaPath:"#/anyOf/3/required",keyword:"required",params:{missingProperty: "install_status"},message:"must have required property '"+"install_status"+"'",schema:schema11.anyOf[3].required,parentSchema:schema11.anyOf[3],data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.engine === undefined){
const err4 = {instancePath,schemaPath:"#/anyOf/4/required",keyword:"required",params:{missingProperty: "engine"},message:"must have required property '"+"engine"+"'",schema:schema11.anyOf[4].required,parentSchema:schema11.anyOf[4],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
var _valid0 = _errs6 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs7 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.node_type === undefined){
const err5 = {instancePath,schemaPath:"#/anyOf/5/required",keyword:"required",params:{missingProperty: "node_type"},message:"must have required property '"+"node_type"+"'",schema:schema11.anyOf[5].required,parentSchema:schema11.anyOf[5],data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
var _valid0 = _errs7 === errors;
valid0 = valid0 || _valid0;
}
}
}
}
}
if(!valid0){
const err6 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf",schema:schema11.anyOf,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type !== undefined){
let data0 = data.resource_type;
if(typeof data0 !== "string"){
const err7 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.resource_type.type,parentSchema:schema11.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if("Cache" !== data0){
const err8 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/const",keyword:"const",params:{allowedValue: "Cache"},message:"must be equal to constant",schema:"Cache",parentSchema:schema11.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 !== "string"){
const err9 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.name.type,parentSchema:schema11.properties.name,data:data1};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.environment !== undefined){
let data2 = data.environment;
if(typeof data2 !== "string"){
const err10 = {instancePath:instancePath+"/environment",schemaPath:"#/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.environment.type,parentSchema:schema11.properties.environment,data:data2};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.install_status !== undefined){
let data3 = data.install_status;
if(typeof data3 !== "string"){
const err11 = {instancePath:instancePath+"/install_status",schemaPath:"#/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.install_status.type,parentSchema:schema11.properties.install_status,data:data3};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.engine !== undefined){
let data4 = data.engine;
if(typeof data4 !== "string"){
const err12 = {instancePath:instancePath+"/engine",schemaPath:"#/properties/engine/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.engine.type,parentSchema:schema11.properties.engine,data:data4};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.node_type !== undefined){
let data5 = data.node_type;
if(typeof data5 !== "string"){
const err13 = {instancePath:instancePath+"/node_type",schemaPath:"#/properties/node_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.node_type.type,parentSchema:schema11.properties.node_type,data:data5};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}

exports["cmdb_application_schema-v1"] = validate11;
const schema12 = {"type":"object","required":["app_id","app_name"],"properties":{"app_id":{"type":"string","description":"The unique identifier for the service or application."},"app_name":{"type":"string","description":"The primary, user-facing name of the application."},"app_description":{"type":"string","description":"A brief summary of the application's purpose."},"app_type":{"type":"string","description":"The type of application (e.g. On-Premise, Cloud)."},"tier":{"enum":["Tier 0","Tier 1","Tier 2","Tier 3","Tier 4","Tier 5","Tier 6"],"description":"The business criticality tier of the application."},"lob":{"type":"string","description":"The line of business the application belongs to."},"division":{"type":"string","description":"The division the application belongs to."},"app_owner":{"type":"string","description":"The primary technical contact or owner."},"business_owner":{"type":"string","description":"The primary business stakeholder."},"support_l1_owner":{"type":"string","description":"The Level 1 support contact."},"support_l2_owner":{"type":"string","description":"The Level 2 support contact."},"support_l3_owner":{"type":"string","description":"The Level 3 support contact."},"rto":{"type":"integer","description":"The Recovery Time Objective for the application in minutes."},"rpo":{"type":"integer","description":"The Recovery Point Objective for the application in minutes."},"status":{"type":"string","description":"The current operational status of the application."},"datacenter_location":{"type":"string","description":"The physical data center location."},"location":{"type":"string","description":"The geographical region, e.g., US, EMEA."},"cloud_primary_location":{"type":"string","description":"The primary cloud location for the application."},"cloud_secondary_location":{"type":"string","description":"The secondary cloud location for the application."},"review_date":{"type":"string","description":"The last review date for this record.","format":"date-time"},"soc1":{"enum":["YES","NO"]},"soc2":{"enum":["YES","NO"]},"sox":{"enum":["YES","NO"]},"infrastructure":{"type":"array","items":{"anyOf":[{"type":"object","required":["resource_type","name"],"properties":{"resource_type":{"type":"string","const":"Database","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"alias":{"type":"string","description":"An alternative name or CNAME for the database."}},"title":"Database"},{"type":"object","required":["resource_type","name","host_name"],"properties":{"resource_type":{"type":"string","const":"Server","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"host_name":{"type":"string","description":"The fully qualified domain name (FQDN) of the server."},"ip_address":{"type":"string","format":"ipv4","description":"The primary IPv4 address of the server."},"os_type":{"type":"string","description":"The operating system running on the server (e.g., 'Linux', 'Windows Server')."}},"title":"Server"},{"type":"object","required":["resource_type","name"],"properties":{"resource_type":{"type":"string","const":"LoadBalancer","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"dns_name":{"type":"string","description":"The public or internal DNS name of the load balancer."},"listener_port":{"type":"integer","description":"The port the load balancer is listening on."}},"title":"LoadBalancer"},{"type":"object","required":["resource_type","name"],"properties":{"resource_type":{"type":"string","const":"Compute","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"instance_type":{"type":"string","description":"The instance size or type (e.g., 't3.medium', 'Standard_D2s_v3')."},"image_id":{"type":"string","description":"The ID of the machine image or template used."}},"title":"Compute"},{"type":"object","required":["resource_type","name"],"properties":{"resource_type":{"type":"string","const":"Storage","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"storage_type":{"type":"string","description":"The type of storage (e.g., 'SSD', 'HDD', 'Object Storage')."},"capacity_gb":{"type":"integer","description":"The total capacity of the storage volume in gigabytes."}},"title":"Storage"},{"type":"object","required":["resource_type","name"],"properties":{"resource_type":{"type":"string","const":"Cache","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"engine":{"type":"string","description":"The caching engine used (e.g., 'Redis', 'Memcached')."},"node_type":{"type":"string","description":"The instance size for the cache nodes."}},"title":"Cache"},{"type":"object","required":["resource_type","name"],"properties":{"resource_type":{"type":"string","const":"Middleware","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"middleware_type":{"type":"string","description":"The type of middleware (e.g., 'Message Broker', 'Application Server', 'Integration Platform')."},"vendor":{"type":"string","description":"The vendor or provider of the middleware (e.g., 'IBM', 'Oracle', 'Apache')."},"version":{"type":"string","description":"The version of the middleware."}},"title":"Middleware"},{"type":"object","required":["resource_type","name"],"properties":{"resource_type":{"type":"string","const":"VPC","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"cidr_block":{"type":"string","description":"The CIDR block for the VPC (e.g., '10.0.0.0/16')."}},"title":"VPC"},{"type":"object","required":["resource_type","name"],"properties":{"resource_type":{"type":"string","const":"SecurityGroup","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"description":{"type":"string","description":"A summary of the security group's purpose."}},"title":"Security Group"},{"type":"object","required":["resource_type","name"],"properties":{"resource_type":{"type":"string","const":"APIGateway","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"endpoint_type":{"enum":["Regional","Edge-Optimized","Private"],"description":"The type of API endpoint."}},"title":"API Gateway"},{"type":"object","required":["resource_type","name"],"properties":{"resource_type":{"type":"string","const":"ContainerOrchestrator","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"orchestrator_type":{"enum":["Kubernetes","ECS","Swarm"],"description":"The container orchestration platform."}},"title":"Container Orchestrator"},{"type":"object","required":["resource_type","name"],"properties":{"resource_type":{"type":"string","const":"MessageQueue","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"queue_type":{"enum":["Standard","FIFO"],"description":"The type of message queue."}},"title":"Message Queue"},{"type":"object","required":["resource_type","name"],"properties":{"resource_type":{"type":"string","const":"IAMRole","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"role_arn":{"type":"string","description":"The Amazon Resource Name (ARN) of the IAM role."}},"title":"IAM Role"}]},"title":"Application Infrastructure","description":"A list of all associated infrastructure resources for the application."}},"$id":"cmdb_application_schema-v1"};
const formats0 = require("ajv-formats/dist/formats").fullFormats["date-time"];
const formats2 = /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/;

function validate11(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="cmdb_application_schema-v1" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.app_id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "app_id"},message:"must have required property '"+"app_id"+"'",schema:schema12.required,parentSchema:schema12,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.app_name === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "app_name"},message:"must have required property '"+"app_name"+"'",schema:schema12.required,parentSchema:schema12,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.app_id !== undefined){
let data0 = data.app_id;
if(typeof data0 !== "string"){
const err2 = {instancePath:instancePath+"/app_id",schemaPath:"#/properties/app_id/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.app_id.type,parentSchema:schema12.properties.app_id,data:data0};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.app_name !== undefined){
let data1 = data.app_name;
if(typeof data1 !== "string"){
const err3 = {instancePath:instancePath+"/app_name",schemaPath:"#/properties/app_name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.app_name.type,parentSchema:schema12.properties.app_name,data:data1};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.app_description !== undefined){
let data2 = data.app_description;
if(typeof data2 !== "string"){
const err4 = {instancePath:instancePath+"/app_description",schemaPath:"#/properties/app_description/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.app_description.type,parentSchema:schema12.properties.app_description,data:data2};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.app_type !== undefined){
let data3 = data.app_type;
if(typeof data3 !== "string"){
const err5 = {instancePath:instancePath+"/app_type",schemaPath:"#/properties/app_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.app_type.type,parentSchema:schema12.properties.app_type,data:data3};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.tier !== undefined){
let data4 = data.tier;
if(!(((((((data4 === "Tier 0") || (data4 === "Tier 1")) || (data4 === "Tier 2")) || (data4 === "Tier 3")) || (data4 === "Tier 4")) || (data4 === "Tier 5")) || (data4 === "Tier 6"))){
const err6 = {instancePath:instancePath+"/tier",schemaPath:"#/properties/tier/enum",keyword:"enum",params:{allowedValues: schema12.properties.tier.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.tier.enum,parentSchema:schema12.properties.tier,data:data4};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.lob !== undefined){
let data5 = data.lob;
if(typeof data5 !== "string"){
const err7 = {instancePath:instancePath+"/lob",schemaPath:"#/properties/lob/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.lob.type,parentSchema:schema12.properties.lob,data:data5};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.division !== undefined){
let data6 = data.division;
if(typeof data6 !== "string"){
const err8 = {instancePath:instancePath+"/division",schemaPath:"#/properties/division/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.division.type,parentSchema:schema12.properties.division,data:data6};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.app_owner !== undefined){
let data7 = data.app_owner;
if(typeof data7 !== "string"){
const err9 = {instancePath:instancePath+"/app_owner",schemaPath:"#/properties/app_owner/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.app_owner.type,parentSchema:schema12.properties.app_owner,data:data7};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.business_owner !== undefined){
let data8 = data.business_owner;
if(typeof data8 !== "string"){
const err10 = {instancePath:instancePath+"/business_owner",schemaPath:"#/properties/business_owner/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.business_owner.type,parentSchema:schema12.properties.business_owner,data:data8};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.support_l1_owner !== undefined){
let data9 = data.support_l1_owner;
if(typeof data9 !== "string"){
const err11 = {instancePath:instancePath+"/support_l1_owner",schemaPath:"#/properties/support_l1_owner/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.support_l1_owner.type,parentSchema:schema12.properties.support_l1_owner,data:data9};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.support_l2_owner !== undefined){
let data10 = data.support_l2_owner;
if(typeof data10 !== "string"){
const err12 = {instancePath:instancePath+"/support_l2_owner",schemaPath:"#/properties/support_l2_owner/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.support_l2_owner.type,parentSchema:schema12.properties.support_l2_owner,data:data10};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.support_l3_owner !== undefined){
let data11 = data.support_l3_owner;
if(typeof data11 !== "string"){
const err13 = {instancePath:instancePath+"/support_l3_owner",schemaPath:"#/properties/support_l3_owner/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.support_l3_owner.type,parentSchema:schema12.properties.support_l3_owner,data:data11};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.rto !== undefined){
let data12 = data.rto;
if(!((typeof data12 == "number") && (!(data12 % 1) && !isNaN(data12)))){
const err14 = {instancePath:instancePath+"/rto",schemaPath:"#/properties/rto/type",keyword:"type",params:{type: "integer"},message:"must be integer",schema:schema12.properties.rto.type,parentSchema:schema12.properties.rto,data:data12};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.rpo !== undefined){
let data13 = data.rpo;
if(!((typeof data13 == "number") && (!(data13 % 1) && !isNaN(data13)))){
const err15 = {instancePath:instancePath+"/rpo",schemaPath:"#/properties/rpo/type",keyword:"type",params:{type: "integer"},message:"must be integer",schema:schema12.properties.rpo.type,parentSchema:schema12.properties.rpo,data:data13};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.status !== undefined){
let data14 = data.status;
if(typeof data14 !== "string"){
const err16 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.status.type,parentSchema:schema12.properties.status,data:data14};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.datacenter_location !== undefined){
let data15 = data.datacenter_location;
if(typeof data15 !== "string"){
const err17 = {instancePath:instancePath+"/datacenter_location",schemaPath:"#/properties/datacenter_location/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.datacenter_location.type,parentSchema:schema12.properties.datacenter_location,data:data15};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.location !== undefined){
let data16 = data.location;
if(typeof data16 !== "string"){
const err18 = {instancePath:instancePath+"/location",schemaPath:"#/properties/location/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.location.type,parentSchema:schema12.properties.location,data:data16};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.cloud_primary_location !== undefined){
let data17 = data.cloud_primary_location;
if(typeof data17 !== "string"){
const err19 = {instancePath:instancePath+"/cloud_primary_location",schemaPath:"#/properties/cloud_primary_location/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.cloud_primary_location.type,parentSchema:schema12.properties.cloud_primary_location,data:data17};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.cloud_secondary_location !== undefined){
let data18 = data.cloud_secondary_location;
if(typeof data18 !== "string"){
const err20 = {instancePath:instancePath+"/cloud_secondary_location",schemaPath:"#/properties/cloud_secondary_location/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.cloud_secondary_location.type,parentSchema:schema12.properties.cloud_secondary_location,data:data18};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.review_date !== undefined){
let data19 = data.review_date;
if(typeof data19 === "string"){
if(!(formats0.validate(data19))){
const err21 = {instancePath:instancePath+"/review_date",schemaPath:"#/properties/review_date/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\"",schema:"date-time",parentSchema:schema12.properties.review_date,data:data19};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/review_date",schemaPath:"#/properties/review_date/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.review_date.type,parentSchema:schema12.properties.review_date,data:data19};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.soc1 !== undefined){
let data20 = data.soc1;
if(!((data20 === "YES") || (data20 === "NO"))){
const err23 = {instancePath:instancePath+"/soc1",schemaPath:"#/properties/soc1/enum",keyword:"enum",params:{allowedValues: schema12.properties.soc1.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.soc1.enum,parentSchema:schema12.properties.soc1,data:data20};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.soc2 !== undefined){
let data21 = data.soc2;
if(!((data21 === "YES") || (data21 === "NO"))){
const err24 = {instancePath:instancePath+"/soc2",schemaPath:"#/properties/soc2/enum",keyword:"enum",params:{allowedValues: schema12.properties.soc2.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.soc2.enum,parentSchema:schema12.properties.soc2,data:data21};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.sox !== undefined){
let data22 = data.sox;
if(!((data22 === "YES") || (data22 === "NO"))){
const err25 = {instancePath:instancePath+"/sox",schemaPath:"#/properties/sox/enum",keyword:"enum",params:{allowedValues: schema12.properties.sox.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.sox.enum,parentSchema:schema12.properties.sox,data:data22};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.infrastructure !== undefined){
let data23 = data.infrastructure;
if(Array.isArray(data23)){
const len0 = data23.length;
for(let i0=0; i0<len0; i0++){
let data24 = data23[i0];
const _errs46 = errors;
let valid3 = false;
const _errs47 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.resource_type === undefined){
const err26 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/0/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema12.properties.infrastructure.items.anyOf[0].required,parentSchema:schema12.properties.infrastructure.items.anyOf[0],data:data24};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(data24.name === undefined){
const err27 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/0/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema12.properties.infrastructure.items.anyOf[0].required,parentSchema:schema12.properties.infrastructure.items.anyOf[0],data:data24};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(data24.resource_type !== undefined){
let data25 = data24.resource_type;
if(typeof data25 !== "string"){
const err28 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/0/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[0].properties.resource_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[0].properties.resource_type,data:data25};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if("Database" !== data25){
const err29 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/0/properties/resource_type/const",keyword:"const",params:{allowedValue: "Database"},message:"must be equal to constant",schema:"Database",parentSchema:schema12.properties.infrastructure.items.anyOf[0].properties.resource_type,data:data25};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data24.name !== undefined){
let data26 = data24.name;
if(typeof data26 !== "string"){
const err30 = {instancePath:instancePath+"/infrastructure/" + i0+"/name",schemaPath:"#/properties/infrastructure/items/anyOf/0/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[0].properties.name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[0].properties.name,data:data26};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data24.environment !== undefined){
let data27 = data24.environment;
if(typeof data27 !== "string"){
const err31 = {instancePath:instancePath+"/infrastructure/" + i0+"/environment",schemaPath:"#/properties/infrastructure/items/anyOf/0/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[0].properties.environment.type,parentSchema:schema12.properties.infrastructure.items.anyOf[0].properties.environment,data:data27};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
if(data24.install_status !== undefined){
let data28 = data24.install_status;
if(typeof data28 !== "string"){
const err32 = {instancePath:instancePath+"/infrastructure/" + i0+"/install_status",schemaPath:"#/properties/infrastructure/items/anyOf/0/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[0].properties.install_status.type,parentSchema:schema12.properties.infrastructure.items.anyOf[0].properties.install_status,data:data28};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data24.alias !== undefined){
let data29 = data24.alias;
if(typeof data29 !== "string"){
const err33 = {instancePath:instancePath+"/infrastructure/" + i0+"/alias",schemaPath:"#/properties/infrastructure/items/anyOf/0/properties/alias/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[0].properties.alias.type,parentSchema:schema12.properties.infrastructure.items.anyOf[0].properties.alias,data:data29};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
else {
const err34 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/0/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.properties.infrastructure.items.anyOf[0].type,parentSchema:schema12.properties.infrastructure.items.anyOf[0],data:data24};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
var _valid0 = _errs47 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const _errs59 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.resource_type === undefined){
const err35 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/1/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema12.properties.infrastructure.items.anyOf[1].required,parentSchema:schema12.properties.infrastructure.items.anyOf[1],data:data24};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data24.name === undefined){
const err36 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/1/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema12.properties.infrastructure.items.anyOf[1].required,parentSchema:schema12.properties.infrastructure.items.anyOf[1],data:data24};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data24.host_name === undefined){
const err37 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/1/required",keyword:"required",params:{missingProperty: "host_name"},message:"must have required property '"+"host_name"+"'",schema:schema12.properties.infrastructure.items.anyOf[1].required,parentSchema:schema12.properties.infrastructure.items.anyOf[1],data:data24};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if(data24.resource_type !== undefined){
let data30 = data24.resource_type;
if(typeof data30 !== "string"){
const err38 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/1/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[1].properties.resource_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[1].properties.resource_type,data:data30};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
if("Server" !== data30){
const err39 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/1/properties/resource_type/const",keyword:"const",params:{allowedValue: "Server"},message:"must be equal to constant",schema:"Server",parentSchema:schema12.properties.infrastructure.items.anyOf[1].properties.resource_type,data:data30};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data24.name !== undefined){
let data31 = data24.name;
if(typeof data31 !== "string"){
const err40 = {instancePath:instancePath+"/infrastructure/" + i0+"/name",schemaPath:"#/properties/infrastructure/items/anyOf/1/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[1].properties.name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[1].properties.name,data:data31};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
if(data24.environment !== undefined){
let data32 = data24.environment;
if(typeof data32 !== "string"){
const err41 = {instancePath:instancePath+"/infrastructure/" + i0+"/environment",schemaPath:"#/properties/infrastructure/items/anyOf/1/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[1].properties.environment.type,parentSchema:schema12.properties.infrastructure.items.anyOf[1].properties.environment,data:data32};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
if(data24.install_status !== undefined){
let data33 = data24.install_status;
if(typeof data33 !== "string"){
const err42 = {instancePath:instancePath+"/infrastructure/" + i0+"/install_status",schemaPath:"#/properties/infrastructure/items/anyOf/1/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[1].properties.install_status.type,parentSchema:schema12.properties.infrastructure.items.anyOf[1].properties.install_status,data:data33};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
if(data24.host_name !== undefined){
let data34 = data24.host_name;
if(typeof data34 !== "string"){
const err43 = {instancePath:instancePath+"/infrastructure/" + i0+"/host_name",schemaPath:"#/properties/infrastructure/items/anyOf/1/properties/host_name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[1].properties.host_name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[1].properties.host_name,data:data34};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data24.ip_address !== undefined){
let data35 = data24.ip_address;
if(typeof data35 === "string"){
if(!(formats2.test(data35))){
const err44 = {instancePath:instancePath+"/infrastructure/" + i0+"/ip_address",schemaPath:"#/properties/infrastructure/items/anyOf/1/properties/ip_address/format",keyword:"format",params:{format: "ipv4"},message:"must match format \""+"ipv4"+"\"",schema:"ipv4",parentSchema:schema12.properties.infrastructure.items.anyOf[1].properties.ip_address,data:data35};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
else {
const err45 = {instancePath:instancePath+"/infrastructure/" + i0+"/ip_address",schemaPath:"#/properties/infrastructure/items/anyOf/1/properties/ip_address/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[1].properties.ip_address.type,parentSchema:schema12.properties.infrastructure.items.anyOf[1].properties.ip_address,data:data35};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data24.os_type !== undefined){
let data36 = data24.os_type;
if(typeof data36 !== "string"){
const err46 = {instancePath:instancePath+"/infrastructure/" + i0+"/os_type",schemaPath:"#/properties/infrastructure/items/anyOf/1/properties/os_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[1].properties.os_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[1].properties.os_type,data:data36};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
}
else {
const err47 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/1/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.properties.infrastructure.items.anyOf[1].type,parentSchema:schema12.properties.infrastructure.items.anyOf[1],data:data24};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
var _valid0 = _errs59 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const _errs75 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.resource_type === undefined){
const err48 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/2/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema12.properties.infrastructure.items.anyOf[2].required,parentSchema:schema12.properties.infrastructure.items.anyOf[2],data:data24};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
if(data24.name === undefined){
const err49 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/2/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema12.properties.infrastructure.items.anyOf[2].required,parentSchema:schema12.properties.infrastructure.items.anyOf[2],data:data24};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
if(data24.resource_type !== undefined){
let data37 = data24.resource_type;
if(typeof data37 !== "string"){
const err50 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/2/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[2].properties.resource_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[2].properties.resource_type,data:data37};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
if("LoadBalancer" !== data37){
const err51 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/2/properties/resource_type/const",keyword:"const",params:{allowedValue: "LoadBalancer"},message:"must be equal to constant",schema:"LoadBalancer",parentSchema:schema12.properties.infrastructure.items.anyOf[2].properties.resource_type,data:data37};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
}
if(data24.name !== undefined){
let data38 = data24.name;
if(typeof data38 !== "string"){
const err52 = {instancePath:instancePath+"/infrastructure/" + i0+"/name",schemaPath:"#/properties/infrastructure/items/anyOf/2/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[2].properties.name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[2].properties.name,data:data38};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
if(data24.environment !== undefined){
let data39 = data24.environment;
if(typeof data39 !== "string"){
const err53 = {instancePath:instancePath+"/infrastructure/" + i0+"/environment",schemaPath:"#/properties/infrastructure/items/anyOf/2/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[2].properties.environment.type,parentSchema:schema12.properties.infrastructure.items.anyOf[2].properties.environment,data:data39};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
if(data24.install_status !== undefined){
let data40 = data24.install_status;
if(typeof data40 !== "string"){
const err54 = {instancePath:instancePath+"/infrastructure/" + i0+"/install_status",schemaPath:"#/properties/infrastructure/items/anyOf/2/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[2].properties.install_status.type,parentSchema:schema12.properties.infrastructure.items.anyOf[2].properties.install_status,data:data40};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
}
if(data24.dns_name !== undefined){
let data41 = data24.dns_name;
if(typeof data41 !== "string"){
const err55 = {instancePath:instancePath+"/infrastructure/" + i0+"/dns_name",schemaPath:"#/properties/infrastructure/items/anyOf/2/properties/dns_name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[2].properties.dns_name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[2].properties.dns_name,data:data41};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
}
if(data24.listener_port !== undefined){
let data42 = data24.listener_port;
if(!((typeof data42 == "number") && (!(data42 % 1) && !isNaN(data42)))){
const err56 = {instancePath:instancePath+"/infrastructure/" + i0+"/listener_port",schemaPath:"#/properties/infrastructure/items/anyOf/2/properties/listener_port/type",keyword:"type",params:{type: "integer"},message:"must be integer",schema:schema12.properties.infrastructure.items.anyOf[2].properties.listener_port.type,parentSchema:schema12.properties.infrastructure.items.anyOf[2].properties.listener_port,data:data42};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
}
else {
const err57 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/2/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.properties.infrastructure.items.anyOf[2].type,parentSchema:schema12.properties.infrastructure.items.anyOf[2],data:data24};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
var _valid0 = _errs75 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const _errs89 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.resource_type === undefined){
const err58 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/3/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema12.properties.infrastructure.items.anyOf[3].required,parentSchema:schema12.properties.infrastructure.items.anyOf[3],data:data24};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
if(data24.name === undefined){
const err59 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/3/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema12.properties.infrastructure.items.anyOf[3].required,parentSchema:schema12.properties.infrastructure.items.anyOf[3],data:data24};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
if(data24.resource_type !== undefined){
let data43 = data24.resource_type;
if(typeof data43 !== "string"){
const err60 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/3/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[3].properties.resource_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[3].properties.resource_type,data:data43};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
if("Compute" !== data43){
const err61 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/3/properties/resource_type/const",keyword:"const",params:{allowedValue: "Compute"},message:"must be equal to constant",schema:"Compute",parentSchema:schema12.properties.infrastructure.items.anyOf[3].properties.resource_type,data:data43};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
}
if(data24.name !== undefined){
let data44 = data24.name;
if(typeof data44 !== "string"){
const err62 = {instancePath:instancePath+"/infrastructure/" + i0+"/name",schemaPath:"#/properties/infrastructure/items/anyOf/3/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[3].properties.name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[3].properties.name,data:data44};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
}
if(data24.environment !== undefined){
let data45 = data24.environment;
if(typeof data45 !== "string"){
const err63 = {instancePath:instancePath+"/infrastructure/" + i0+"/environment",schemaPath:"#/properties/infrastructure/items/anyOf/3/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[3].properties.environment.type,parentSchema:schema12.properties.infrastructure.items.anyOf[3].properties.environment,data:data45};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
}
if(data24.install_status !== undefined){
let data46 = data24.install_status;
if(typeof data46 !== "string"){
const err64 = {instancePath:instancePath+"/infrastructure/" + i0+"/install_status",schemaPath:"#/properties/infrastructure/items/anyOf/3/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[3].properties.install_status.type,parentSchema:schema12.properties.infrastructure.items.anyOf[3].properties.install_status,data:data46};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
}
if(data24.instance_type !== undefined){
let data47 = data24.instance_type;
if(typeof data47 !== "string"){
const err65 = {instancePath:instancePath+"/infrastructure/" + i0+"/instance_type",schemaPath:"#/properties/infrastructure/items/anyOf/3/properties/instance_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[3].properties.instance_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[3].properties.instance_type,data:data47};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
}
if(data24.image_id !== undefined){
let data48 = data24.image_id;
if(typeof data48 !== "string"){
const err66 = {instancePath:instancePath+"/infrastructure/" + i0+"/image_id",schemaPath:"#/properties/infrastructure/items/anyOf/3/properties/image_id/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[3].properties.image_id.type,parentSchema:schema12.properties.infrastructure.items.anyOf[3].properties.image_id,data:data48};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
}
}
else {
const err67 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/3/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.properties.infrastructure.items.anyOf[3].type,parentSchema:schema12.properties.infrastructure.items.anyOf[3],data:data24};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
var _valid0 = _errs89 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const _errs103 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.resource_type === undefined){
const err68 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/4/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema12.properties.infrastructure.items.anyOf[4].required,parentSchema:schema12.properties.infrastructure.items.anyOf[4],data:data24};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
if(data24.name === undefined){
const err69 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/4/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema12.properties.infrastructure.items.anyOf[4].required,parentSchema:schema12.properties.infrastructure.items.anyOf[4],data:data24};
if(vErrors === null){
vErrors = [err69];
}
else {
vErrors.push(err69);
}
errors++;
}
if(data24.resource_type !== undefined){
let data49 = data24.resource_type;
if(typeof data49 !== "string"){
const err70 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/4/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[4].properties.resource_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[4].properties.resource_type,data:data49};
if(vErrors === null){
vErrors = [err70];
}
else {
vErrors.push(err70);
}
errors++;
}
if("Storage" !== data49){
const err71 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/4/properties/resource_type/const",keyword:"const",params:{allowedValue: "Storage"},message:"must be equal to constant",schema:"Storage",parentSchema:schema12.properties.infrastructure.items.anyOf[4].properties.resource_type,data:data49};
if(vErrors === null){
vErrors = [err71];
}
else {
vErrors.push(err71);
}
errors++;
}
}
if(data24.name !== undefined){
let data50 = data24.name;
if(typeof data50 !== "string"){
const err72 = {instancePath:instancePath+"/infrastructure/" + i0+"/name",schemaPath:"#/properties/infrastructure/items/anyOf/4/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[4].properties.name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[4].properties.name,data:data50};
if(vErrors === null){
vErrors = [err72];
}
else {
vErrors.push(err72);
}
errors++;
}
}
if(data24.environment !== undefined){
let data51 = data24.environment;
if(typeof data51 !== "string"){
const err73 = {instancePath:instancePath+"/infrastructure/" + i0+"/environment",schemaPath:"#/properties/infrastructure/items/anyOf/4/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[4].properties.environment.type,parentSchema:schema12.properties.infrastructure.items.anyOf[4].properties.environment,data:data51};
if(vErrors === null){
vErrors = [err73];
}
else {
vErrors.push(err73);
}
errors++;
}
}
if(data24.install_status !== undefined){
let data52 = data24.install_status;
if(typeof data52 !== "string"){
const err74 = {instancePath:instancePath+"/infrastructure/" + i0+"/install_status",schemaPath:"#/properties/infrastructure/items/anyOf/4/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[4].properties.install_status.type,parentSchema:schema12.properties.infrastructure.items.anyOf[4].properties.install_status,data:data52};
if(vErrors === null){
vErrors = [err74];
}
else {
vErrors.push(err74);
}
errors++;
}
}
if(data24.storage_type !== undefined){
let data53 = data24.storage_type;
if(typeof data53 !== "string"){
const err75 = {instancePath:instancePath+"/infrastructure/" + i0+"/storage_type",schemaPath:"#/properties/infrastructure/items/anyOf/4/properties/storage_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[4].properties.storage_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[4].properties.storage_type,data:data53};
if(vErrors === null){
vErrors = [err75];
}
else {
vErrors.push(err75);
}
errors++;
}
}
if(data24.capacity_gb !== undefined){
let data54 = data24.capacity_gb;
if(!((typeof data54 == "number") && (!(data54 % 1) && !isNaN(data54)))){
const err76 = {instancePath:instancePath+"/infrastructure/" + i0+"/capacity_gb",schemaPath:"#/properties/infrastructure/items/anyOf/4/properties/capacity_gb/type",keyword:"type",params:{type: "integer"},message:"must be integer",schema:schema12.properties.infrastructure.items.anyOf[4].properties.capacity_gb.type,parentSchema:schema12.properties.infrastructure.items.anyOf[4].properties.capacity_gb,data:data54};
if(vErrors === null){
vErrors = [err76];
}
else {
vErrors.push(err76);
}
errors++;
}
}
}
else {
const err77 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/4/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.properties.infrastructure.items.anyOf[4].type,parentSchema:schema12.properties.infrastructure.items.anyOf[4],data:data24};
if(vErrors === null){
vErrors = [err77];
}
else {
vErrors.push(err77);
}
errors++;
}
var _valid0 = _errs103 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const _errs117 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.resource_type === undefined){
const err78 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/5/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema12.properties.infrastructure.items.anyOf[5].required,parentSchema:schema12.properties.infrastructure.items.anyOf[5],data:data24};
if(vErrors === null){
vErrors = [err78];
}
else {
vErrors.push(err78);
}
errors++;
}
if(data24.name === undefined){
const err79 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/5/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema12.properties.infrastructure.items.anyOf[5].required,parentSchema:schema12.properties.infrastructure.items.anyOf[5],data:data24};
if(vErrors === null){
vErrors = [err79];
}
else {
vErrors.push(err79);
}
errors++;
}
if(data24.resource_type !== undefined){
let data55 = data24.resource_type;
if(typeof data55 !== "string"){
const err80 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/5/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[5].properties.resource_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[5].properties.resource_type,data:data55};
if(vErrors === null){
vErrors = [err80];
}
else {
vErrors.push(err80);
}
errors++;
}
if("Cache" !== data55){
const err81 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/5/properties/resource_type/const",keyword:"const",params:{allowedValue: "Cache"},message:"must be equal to constant",schema:"Cache",parentSchema:schema12.properties.infrastructure.items.anyOf[5].properties.resource_type,data:data55};
if(vErrors === null){
vErrors = [err81];
}
else {
vErrors.push(err81);
}
errors++;
}
}
if(data24.name !== undefined){
let data56 = data24.name;
if(typeof data56 !== "string"){
const err82 = {instancePath:instancePath+"/infrastructure/" + i0+"/name",schemaPath:"#/properties/infrastructure/items/anyOf/5/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[5].properties.name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[5].properties.name,data:data56};
if(vErrors === null){
vErrors = [err82];
}
else {
vErrors.push(err82);
}
errors++;
}
}
if(data24.environment !== undefined){
let data57 = data24.environment;
if(typeof data57 !== "string"){
const err83 = {instancePath:instancePath+"/infrastructure/" + i0+"/environment",schemaPath:"#/properties/infrastructure/items/anyOf/5/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[5].properties.environment.type,parentSchema:schema12.properties.infrastructure.items.anyOf[5].properties.environment,data:data57};
if(vErrors === null){
vErrors = [err83];
}
else {
vErrors.push(err83);
}
errors++;
}
}
if(data24.install_status !== undefined){
let data58 = data24.install_status;
if(typeof data58 !== "string"){
const err84 = {instancePath:instancePath+"/infrastructure/" + i0+"/install_status",schemaPath:"#/properties/infrastructure/items/anyOf/5/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[5].properties.install_status.type,parentSchema:schema12.properties.infrastructure.items.anyOf[5].properties.install_status,data:data58};
if(vErrors === null){
vErrors = [err84];
}
else {
vErrors.push(err84);
}
errors++;
}
}
if(data24.engine !== undefined){
let data59 = data24.engine;
if(typeof data59 !== "string"){
const err85 = {instancePath:instancePath+"/infrastructure/" + i0+"/engine",schemaPath:"#/properties/infrastructure/items/anyOf/5/properties/engine/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[5].properties.engine.type,parentSchema:schema12.properties.infrastructure.items.anyOf[5].properties.engine,data:data59};
if(vErrors === null){
vErrors = [err85];
}
else {
vErrors.push(err85);
}
errors++;
}
}
if(data24.node_type !== undefined){
let data60 = data24.node_type;
if(typeof data60 !== "string"){
const err86 = {instancePath:instancePath+"/infrastructure/" + i0+"/node_type",schemaPath:"#/properties/infrastructure/items/anyOf/5/properties/node_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[5].properties.node_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[5].properties.node_type,data:data60};
if(vErrors === null){
vErrors = [err86];
}
else {
vErrors.push(err86);
}
errors++;
}
}
}
else {
const err87 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/5/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.properties.infrastructure.items.anyOf[5].type,parentSchema:schema12.properties.infrastructure.items.anyOf[5],data:data24};
if(vErrors === null){
vErrors = [err87];
}
else {
vErrors.push(err87);
}
errors++;
}
var _valid0 = _errs117 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const _errs131 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.resource_type === undefined){
const err88 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/6/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema12.properties.infrastructure.items.anyOf[6].required,parentSchema:schema12.properties.infrastructure.items.anyOf[6],data:data24};
if(vErrors === null){
vErrors = [err88];
}
else {
vErrors.push(err88);
}
errors++;
}
if(data24.name === undefined){
const err89 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/6/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema12.properties.infrastructure.items.anyOf[6].required,parentSchema:schema12.properties.infrastructure.items.anyOf[6],data:data24};
if(vErrors === null){
vErrors = [err89];
}
else {
vErrors.push(err89);
}
errors++;
}
if(data24.resource_type !== undefined){
let data61 = data24.resource_type;
if(typeof data61 !== "string"){
const err90 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/6/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[6].properties.resource_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[6].properties.resource_type,data:data61};
if(vErrors === null){
vErrors = [err90];
}
else {
vErrors.push(err90);
}
errors++;
}
if("Middleware" !== data61){
const err91 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/6/properties/resource_type/const",keyword:"const",params:{allowedValue: "Middleware"},message:"must be equal to constant",schema:"Middleware",parentSchema:schema12.properties.infrastructure.items.anyOf[6].properties.resource_type,data:data61};
if(vErrors === null){
vErrors = [err91];
}
else {
vErrors.push(err91);
}
errors++;
}
}
if(data24.name !== undefined){
let data62 = data24.name;
if(typeof data62 !== "string"){
const err92 = {instancePath:instancePath+"/infrastructure/" + i0+"/name",schemaPath:"#/properties/infrastructure/items/anyOf/6/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[6].properties.name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[6].properties.name,data:data62};
if(vErrors === null){
vErrors = [err92];
}
else {
vErrors.push(err92);
}
errors++;
}
}
if(data24.environment !== undefined){
let data63 = data24.environment;
if(typeof data63 !== "string"){
const err93 = {instancePath:instancePath+"/infrastructure/" + i0+"/environment",schemaPath:"#/properties/infrastructure/items/anyOf/6/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[6].properties.environment.type,parentSchema:schema12.properties.infrastructure.items.anyOf[6].properties.environment,data:data63};
if(vErrors === null){
vErrors = [err93];
}
else {
vErrors.push(err93);
}
errors++;
}
}
if(data24.install_status !== undefined){
let data64 = data24.install_status;
if(typeof data64 !== "string"){
const err94 = {instancePath:instancePath+"/infrastructure/" + i0+"/install_status",schemaPath:"#/properties/infrastructure/items/anyOf/6/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[6].properties.install_status.type,parentSchema:schema12.properties.infrastructure.items.anyOf[6].properties.install_status,data:data64};
if(vErrors === null){
vErrors = [err94];
}
else {
vErrors.push(err94);
}
errors++;
}
}
if(data24.middleware_type !== undefined){
let data65 = data24.middleware_type;
if(typeof data65 !== "string"){
const err95 = {instancePath:instancePath+"/infrastructure/" + i0+"/middleware_type",schemaPath:"#/properties/infrastructure/items/anyOf/6/properties/middleware_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[6].properties.middleware_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[6].properties.middleware_type,data:data65};
if(vErrors === null){
vErrors = [err95];
}
else {
vErrors.push(err95);
}
errors++;
}
}
if(data24.vendor !== undefined){
let data66 = data24.vendor;
if(typeof data66 !== "string"){
const err96 = {instancePath:instancePath+"/infrastructure/" + i0+"/vendor",schemaPath:"#/properties/infrastructure/items/anyOf/6/properties/vendor/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[6].properties.vendor.type,parentSchema:schema12.properties.infrastructure.items.anyOf[6].properties.vendor,data:data66};
if(vErrors === null){
vErrors = [err96];
}
else {
vErrors.push(err96);
}
errors++;
}
}
if(data24.version !== undefined){
let data67 = data24.version;
if(typeof data67 !== "string"){
const err97 = {instancePath:instancePath+"/infrastructure/" + i0+"/version",schemaPath:"#/properties/infrastructure/items/anyOf/6/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[6].properties.version.type,parentSchema:schema12.properties.infrastructure.items.anyOf[6].properties.version,data:data67};
if(vErrors === null){
vErrors = [err97];
}
else {
vErrors.push(err97);
}
errors++;
}
}
}
else {
const err98 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/6/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.properties.infrastructure.items.anyOf[6].type,parentSchema:schema12.properties.infrastructure.items.anyOf[6],data:data24};
if(vErrors === null){
vErrors = [err98];
}
else {
vErrors.push(err98);
}
errors++;
}
var _valid0 = _errs131 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const _errs147 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.resource_type === undefined){
const err99 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/7/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema12.properties.infrastructure.items.anyOf[7].required,parentSchema:schema12.properties.infrastructure.items.anyOf[7],data:data24};
if(vErrors === null){
vErrors = [err99];
}
else {
vErrors.push(err99);
}
errors++;
}
if(data24.name === undefined){
const err100 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/7/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema12.properties.infrastructure.items.anyOf[7].required,parentSchema:schema12.properties.infrastructure.items.anyOf[7],data:data24};
if(vErrors === null){
vErrors = [err100];
}
else {
vErrors.push(err100);
}
errors++;
}
if(data24.resource_type !== undefined){
let data68 = data24.resource_type;
if(typeof data68 !== "string"){
const err101 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/7/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[7].properties.resource_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[7].properties.resource_type,data:data68};
if(vErrors === null){
vErrors = [err101];
}
else {
vErrors.push(err101);
}
errors++;
}
if("VPC" !== data68){
const err102 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/7/properties/resource_type/const",keyword:"const",params:{allowedValue: "VPC"},message:"must be equal to constant",schema:"VPC",parentSchema:schema12.properties.infrastructure.items.anyOf[7].properties.resource_type,data:data68};
if(vErrors === null){
vErrors = [err102];
}
else {
vErrors.push(err102);
}
errors++;
}
}
if(data24.name !== undefined){
let data69 = data24.name;
if(typeof data69 !== "string"){
const err103 = {instancePath:instancePath+"/infrastructure/" + i0+"/name",schemaPath:"#/properties/infrastructure/items/anyOf/7/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[7].properties.name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[7].properties.name,data:data69};
if(vErrors === null){
vErrors = [err103];
}
else {
vErrors.push(err103);
}
errors++;
}
}
if(data24.environment !== undefined){
let data70 = data24.environment;
if(typeof data70 !== "string"){
const err104 = {instancePath:instancePath+"/infrastructure/" + i0+"/environment",schemaPath:"#/properties/infrastructure/items/anyOf/7/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[7].properties.environment.type,parentSchema:schema12.properties.infrastructure.items.anyOf[7].properties.environment,data:data70};
if(vErrors === null){
vErrors = [err104];
}
else {
vErrors.push(err104);
}
errors++;
}
}
if(data24.install_status !== undefined){
let data71 = data24.install_status;
if(typeof data71 !== "string"){
const err105 = {instancePath:instancePath+"/infrastructure/" + i0+"/install_status",schemaPath:"#/properties/infrastructure/items/anyOf/7/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[7].properties.install_status.type,parentSchema:schema12.properties.infrastructure.items.anyOf[7].properties.install_status,data:data71};
if(vErrors === null){
vErrors = [err105];
}
else {
vErrors.push(err105);
}
errors++;
}
}
if(data24.cidr_block !== undefined){
let data72 = data24.cidr_block;
if(typeof data72 !== "string"){
const err106 = {instancePath:instancePath+"/infrastructure/" + i0+"/cidr_block",schemaPath:"#/properties/infrastructure/items/anyOf/7/properties/cidr_block/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[7].properties.cidr_block.type,parentSchema:schema12.properties.infrastructure.items.anyOf[7].properties.cidr_block,data:data72};
if(vErrors === null){
vErrors = [err106];
}
else {
vErrors.push(err106);
}
errors++;
}
}
}
else {
const err107 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/7/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.properties.infrastructure.items.anyOf[7].type,parentSchema:schema12.properties.infrastructure.items.anyOf[7],data:data24};
if(vErrors === null){
vErrors = [err107];
}
else {
vErrors.push(err107);
}
errors++;
}
var _valid0 = _errs147 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const _errs159 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.resource_type === undefined){
const err108 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/8/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema12.properties.infrastructure.items.anyOf[8].required,parentSchema:schema12.properties.infrastructure.items.anyOf[8],data:data24};
if(vErrors === null){
vErrors = [err108];
}
else {
vErrors.push(err108);
}
errors++;
}
if(data24.name === undefined){
const err109 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/8/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema12.properties.infrastructure.items.anyOf[8].required,parentSchema:schema12.properties.infrastructure.items.anyOf[8],data:data24};
if(vErrors === null){
vErrors = [err109];
}
else {
vErrors.push(err109);
}
errors++;
}
if(data24.resource_type !== undefined){
let data73 = data24.resource_type;
if(typeof data73 !== "string"){
const err110 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/8/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[8].properties.resource_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[8].properties.resource_type,data:data73};
if(vErrors === null){
vErrors = [err110];
}
else {
vErrors.push(err110);
}
errors++;
}
if("SecurityGroup" !== data73){
const err111 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/8/properties/resource_type/const",keyword:"const",params:{allowedValue: "SecurityGroup"},message:"must be equal to constant",schema:"SecurityGroup",parentSchema:schema12.properties.infrastructure.items.anyOf[8].properties.resource_type,data:data73};
if(vErrors === null){
vErrors = [err111];
}
else {
vErrors.push(err111);
}
errors++;
}
}
if(data24.name !== undefined){
let data74 = data24.name;
if(typeof data74 !== "string"){
const err112 = {instancePath:instancePath+"/infrastructure/" + i0+"/name",schemaPath:"#/properties/infrastructure/items/anyOf/8/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[8].properties.name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[8].properties.name,data:data74};
if(vErrors === null){
vErrors = [err112];
}
else {
vErrors.push(err112);
}
errors++;
}
}
if(data24.environment !== undefined){
let data75 = data24.environment;
if(typeof data75 !== "string"){
const err113 = {instancePath:instancePath+"/infrastructure/" + i0+"/environment",schemaPath:"#/properties/infrastructure/items/anyOf/8/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[8].properties.environment.type,parentSchema:schema12.properties.infrastructure.items.anyOf[8].properties.environment,data:data75};
if(vErrors === null){
vErrors = [err113];
}
else {
vErrors.push(err113);
}
errors++;
}
}
if(data24.install_status !== undefined){
let data76 = data24.install_status;
if(typeof data76 !== "string"){
const err114 = {instancePath:instancePath+"/infrastructure/" + i0+"/install_status",schemaPath:"#/properties/infrastructure/items/anyOf/8/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[8].properties.install_status.type,parentSchema:schema12.properties.infrastructure.items.anyOf[8].properties.install_status,data:data76};
if(vErrors === null){
vErrors = [err114];
}
else {
vErrors.push(err114);
}
errors++;
}
}
if(data24.description !== undefined){
let data77 = data24.description;
if(typeof data77 !== "string"){
const err115 = {instancePath:instancePath+"/infrastructure/" + i0+"/description",schemaPath:"#/properties/infrastructure/items/anyOf/8/properties/description/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[8].properties.description.type,parentSchema:schema12.properties.infrastructure.items.anyOf[8].properties.description,data:data77};
if(vErrors === null){
vErrors = [err115];
}
else {
vErrors.push(err115);
}
errors++;
}
}
}
else {
const err116 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/8/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.properties.infrastructure.items.anyOf[8].type,parentSchema:schema12.properties.infrastructure.items.anyOf[8],data:data24};
if(vErrors === null){
vErrors = [err116];
}
else {
vErrors.push(err116);
}
errors++;
}
var _valid0 = _errs159 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const _errs171 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.resource_type === undefined){
const err117 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/9/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema12.properties.infrastructure.items.anyOf[9].required,parentSchema:schema12.properties.infrastructure.items.anyOf[9],data:data24};
if(vErrors === null){
vErrors = [err117];
}
else {
vErrors.push(err117);
}
errors++;
}
if(data24.name === undefined){
const err118 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/9/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema12.properties.infrastructure.items.anyOf[9].required,parentSchema:schema12.properties.infrastructure.items.anyOf[9],data:data24};
if(vErrors === null){
vErrors = [err118];
}
else {
vErrors.push(err118);
}
errors++;
}
if(data24.resource_type !== undefined){
let data78 = data24.resource_type;
if(typeof data78 !== "string"){
const err119 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/9/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[9].properties.resource_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[9].properties.resource_type,data:data78};
if(vErrors === null){
vErrors = [err119];
}
else {
vErrors.push(err119);
}
errors++;
}
if("APIGateway" !== data78){
const err120 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/9/properties/resource_type/const",keyword:"const",params:{allowedValue: "APIGateway"},message:"must be equal to constant",schema:"APIGateway",parentSchema:schema12.properties.infrastructure.items.anyOf[9].properties.resource_type,data:data78};
if(vErrors === null){
vErrors = [err120];
}
else {
vErrors.push(err120);
}
errors++;
}
}
if(data24.name !== undefined){
let data79 = data24.name;
if(typeof data79 !== "string"){
const err121 = {instancePath:instancePath+"/infrastructure/" + i0+"/name",schemaPath:"#/properties/infrastructure/items/anyOf/9/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[9].properties.name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[9].properties.name,data:data79};
if(vErrors === null){
vErrors = [err121];
}
else {
vErrors.push(err121);
}
errors++;
}
}
if(data24.environment !== undefined){
let data80 = data24.environment;
if(typeof data80 !== "string"){
const err122 = {instancePath:instancePath+"/infrastructure/" + i0+"/environment",schemaPath:"#/properties/infrastructure/items/anyOf/9/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[9].properties.environment.type,parentSchema:schema12.properties.infrastructure.items.anyOf[9].properties.environment,data:data80};
if(vErrors === null){
vErrors = [err122];
}
else {
vErrors.push(err122);
}
errors++;
}
}
if(data24.install_status !== undefined){
let data81 = data24.install_status;
if(typeof data81 !== "string"){
const err123 = {instancePath:instancePath+"/infrastructure/" + i0+"/install_status",schemaPath:"#/properties/infrastructure/items/anyOf/9/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[9].properties.install_status.type,parentSchema:schema12.properties.infrastructure.items.anyOf[9].properties.install_status,data:data81};
if(vErrors === null){
vErrors = [err123];
}
else {
vErrors.push(err123);
}
errors++;
}
}
if(data24.endpoint_type !== undefined){
let data82 = data24.endpoint_type;
if(!(((data82 === "Regional") || (data82 === "Edge-Optimized")) || (data82 === "Private"))){
const err124 = {instancePath:instancePath+"/infrastructure/" + i0+"/endpoint_type",schemaPath:"#/properties/infrastructure/items/anyOf/9/properties/endpoint_type/enum",keyword:"enum",params:{allowedValues: schema12.properties.infrastructure.items.anyOf[9].properties.endpoint_type.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.infrastructure.items.anyOf[9].properties.endpoint_type.enum,parentSchema:schema12.properties.infrastructure.items.anyOf[9].properties.endpoint_type,data:data82};
if(vErrors === null){
vErrors = [err124];
}
else {
vErrors.push(err124);
}
errors++;
}
}
}
else {
const err125 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/9/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.properties.infrastructure.items.anyOf[9].type,parentSchema:schema12.properties.infrastructure.items.anyOf[9],data:data24};
if(vErrors === null){
vErrors = [err125];
}
else {
vErrors.push(err125);
}
errors++;
}
var _valid0 = _errs171 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const _errs182 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.resource_type === undefined){
const err126 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/10/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema12.properties.infrastructure.items.anyOf[10].required,parentSchema:schema12.properties.infrastructure.items.anyOf[10],data:data24};
if(vErrors === null){
vErrors = [err126];
}
else {
vErrors.push(err126);
}
errors++;
}
if(data24.name === undefined){
const err127 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/10/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema12.properties.infrastructure.items.anyOf[10].required,parentSchema:schema12.properties.infrastructure.items.anyOf[10],data:data24};
if(vErrors === null){
vErrors = [err127];
}
else {
vErrors.push(err127);
}
errors++;
}
if(data24.resource_type !== undefined){
let data83 = data24.resource_type;
if(typeof data83 !== "string"){
const err128 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/10/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[10].properties.resource_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[10].properties.resource_type,data:data83};
if(vErrors === null){
vErrors = [err128];
}
else {
vErrors.push(err128);
}
errors++;
}
if("ContainerOrchestrator" !== data83){
const err129 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/10/properties/resource_type/const",keyword:"const",params:{allowedValue: "ContainerOrchestrator"},message:"must be equal to constant",schema:"ContainerOrchestrator",parentSchema:schema12.properties.infrastructure.items.anyOf[10].properties.resource_type,data:data83};
if(vErrors === null){
vErrors = [err129];
}
else {
vErrors.push(err129);
}
errors++;
}
}
if(data24.name !== undefined){
let data84 = data24.name;
if(typeof data84 !== "string"){
const err130 = {instancePath:instancePath+"/infrastructure/" + i0+"/name",schemaPath:"#/properties/infrastructure/items/anyOf/10/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[10].properties.name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[10].properties.name,data:data84};
if(vErrors === null){
vErrors = [err130];
}
else {
vErrors.push(err130);
}
errors++;
}
}
if(data24.environment !== undefined){
let data85 = data24.environment;
if(typeof data85 !== "string"){
const err131 = {instancePath:instancePath+"/infrastructure/" + i0+"/environment",schemaPath:"#/properties/infrastructure/items/anyOf/10/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[10].properties.environment.type,parentSchema:schema12.properties.infrastructure.items.anyOf[10].properties.environment,data:data85};
if(vErrors === null){
vErrors = [err131];
}
else {
vErrors.push(err131);
}
errors++;
}
}
if(data24.install_status !== undefined){
let data86 = data24.install_status;
if(typeof data86 !== "string"){
const err132 = {instancePath:instancePath+"/infrastructure/" + i0+"/install_status",schemaPath:"#/properties/infrastructure/items/anyOf/10/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[10].properties.install_status.type,parentSchema:schema12.properties.infrastructure.items.anyOf[10].properties.install_status,data:data86};
if(vErrors === null){
vErrors = [err132];
}
else {
vErrors.push(err132);
}
errors++;
}
}
if(data24.orchestrator_type !== undefined){
let data87 = data24.orchestrator_type;
if(!(((data87 === "Kubernetes") || (data87 === "ECS")) || (data87 === "Swarm"))){
const err133 = {instancePath:instancePath+"/infrastructure/" + i0+"/orchestrator_type",schemaPath:"#/properties/infrastructure/items/anyOf/10/properties/orchestrator_type/enum",keyword:"enum",params:{allowedValues: schema12.properties.infrastructure.items.anyOf[10].properties.orchestrator_type.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.infrastructure.items.anyOf[10].properties.orchestrator_type.enum,parentSchema:schema12.properties.infrastructure.items.anyOf[10].properties.orchestrator_type,data:data87};
if(vErrors === null){
vErrors = [err133];
}
else {
vErrors.push(err133);
}
errors++;
}
}
}
else {
const err134 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/10/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.properties.infrastructure.items.anyOf[10].type,parentSchema:schema12.properties.infrastructure.items.anyOf[10],data:data24};
if(vErrors === null){
vErrors = [err134];
}
else {
vErrors.push(err134);
}
errors++;
}
var _valid0 = _errs182 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const _errs193 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.resource_type === undefined){
const err135 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/11/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema12.properties.infrastructure.items.anyOf[11].required,parentSchema:schema12.properties.infrastructure.items.anyOf[11],data:data24};
if(vErrors === null){
vErrors = [err135];
}
else {
vErrors.push(err135);
}
errors++;
}
if(data24.name === undefined){
const err136 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/11/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema12.properties.infrastructure.items.anyOf[11].required,parentSchema:schema12.properties.infrastructure.items.anyOf[11],data:data24};
if(vErrors === null){
vErrors = [err136];
}
else {
vErrors.push(err136);
}
errors++;
}
if(data24.resource_type !== undefined){
let data88 = data24.resource_type;
if(typeof data88 !== "string"){
const err137 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/11/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[11].properties.resource_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[11].properties.resource_type,data:data88};
if(vErrors === null){
vErrors = [err137];
}
else {
vErrors.push(err137);
}
errors++;
}
if("MessageQueue" !== data88){
const err138 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/11/properties/resource_type/const",keyword:"const",params:{allowedValue: "MessageQueue"},message:"must be equal to constant",schema:"MessageQueue",parentSchema:schema12.properties.infrastructure.items.anyOf[11].properties.resource_type,data:data88};
if(vErrors === null){
vErrors = [err138];
}
else {
vErrors.push(err138);
}
errors++;
}
}
if(data24.name !== undefined){
let data89 = data24.name;
if(typeof data89 !== "string"){
const err139 = {instancePath:instancePath+"/infrastructure/" + i0+"/name",schemaPath:"#/properties/infrastructure/items/anyOf/11/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[11].properties.name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[11].properties.name,data:data89};
if(vErrors === null){
vErrors = [err139];
}
else {
vErrors.push(err139);
}
errors++;
}
}
if(data24.environment !== undefined){
let data90 = data24.environment;
if(typeof data90 !== "string"){
const err140 = {instancePath:instancePath+"/infrastructure/" + i0+"/environment",schemaPath:"#/properties/infrastructure/items/anyOf/11/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[11].properties.environment.type,parentSchema:schema12.properties.infrastructure.items.anyOf[11].properties.environment,data:data90};
if(vErrors === null){
vErrors = [err140];
}
else {
vErrors.push(err140);
}
errors++;
}
}
if(data24.install_status !== undefined){
let data91 = data24.install_status;
if(typeof data91 !== "string"){
const err141 = {instancePath:instancePath+"/infrastructure/" + i0+"/install_status",schemaPath:"#/properties/infrastructure/items/anyOf/11/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[11].properties.install_status.type,parentSchema:schema12.properties.infrastructure.items.anyOf[11].properties.install_status,data:data91};
if(vErrors === null){
vErrors = [err141];
}
else {
vErrors.push(err141);
}
errors++;
}
}
if(data24.queue_type !== undefined){
let data92 = data24.queue_type;
if(!((data92 === "Standard") || (data92 === "FIFO"))){
const err142 = {instancePath:instancePath+"/infrastructure/" + i0+"/queue_type",schemaPath:"#/properties/infrastructure/items/anyOf/11/properties/queue_type/enum",keyword:"enum",params:{allowedValues: schema12.properties.infrastructure.items.anyOf[11].properties.queue_type.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.infrastructure.items.anyOf[11].properties.queue_type.enum,parentSchema:schema12.properties.infrastructure.items.anyOf[11].properties.queue_type,data:data92};
if(vErrors === null){
vErrors = [err142];
}
else {
vErrors.push(err142);
}
errors++;
}
}
}
else {
const err143 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/11/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.properties.infrastructure.items.anyOf[11].type,parentSchema:schema12.properties.infrastructure.items.anyOf[11],data:data24};
if(vErrors === null){
vErrors = [err143];
}
else {
vErrors.push(err143);
}
errors++;
}
var _valid0 = _errs193 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const _errs204 = errors;
if(data24 && typeof data24 == "object" && !Array.isArray(data24)){
if(data24.resource_type === undefined){
const err144 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/12/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema12.properties.infrastructure.items.anyOf[12].required,parentSchema:schema12.properties.infrastructure.items.anyOf[12],data:data24};
if(vErrors === null){
vErrors = [err144];
}
else {
vErrors.push(err144);
}
errors++;
}
if(data24.name === undefined){
const err145 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/12/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema12.properties.infrastructure.items.anyOf[12].required,parentSchema:schema12.properties.infrastructure.items.anyOf[12],data:data24};
if(vErrors === null){
vErrors = [err145];
}
else {
vErrors.push(err145);
}
errors++;
}
if(data24.resource_type !== undefined){
let data93 = data24.resource_type;
if(typeof data93 !== "string"){
const err146 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/12/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[12].properties.resource_type.type,parentSchema:schema12.properties.infrastructure.items.anyOf[12].properties.resource_type,data:data93};
if(vErrors === null){
vErrors = [err146];
}
else {
vErrors.push(err146);
}
errors++;
}
if("IAMRole" !== data93){
const err147 = {instancePath:instancePath+"/infrastructure/" + i0+"/resource_type",schemaPath:"#/properties/infrastructure/items/anyOf/12/properties/resource_type/const",keyword:"const",params:{allowedValue: "IAMRole"},message:"must be equal to constant",schema:"IAMRole",parentSchema:schema12.properties.infrastructure.items.anyOf[12].properties.resource_type,data:data93};
if(vErrors === null){
vErrors = [err147];
}
else {
vErrors.push(err147);
}
errors++;
}
}
if(data24.name !== undefined){
let data94 = data24.name;
if(typeof data94 !== "string"){
const err148 = {instancePath:instancePath+"/infrastructure/" + i0+"/name",schemaPath:"#/properties/infrastructure/items/anyOf/12/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[12].properties.name.type,parentSchema:schema12.properties.infrastructure.items.anyOf[12].properties.name,data:data94};
if(vErrors === null){
vErrors = [err148];
}
else {
vErrors.push(err148);
}
errors++;
}
}
if(data24.environment !== undefined){
let data95 = data24.environment;
if(typeof data95 !== "string"){
const err149 = {instancePath:instancePath+"/infrastructure/" + i0+"/environment",schemaPath:"#/properties/infrastructure/items/anyOf/12/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[12].properties.environment.type,parentSchema:schema12.properties.infrastructure.items.anyOf[12].properties.environment,data:data95};
if(vErrors === null){
vErrors = [err149];
}
else {
vErrors.push(err149);
}
errors++;
}
}
if(data24.install_status !== undefined){
let data96 = data24.install_status;
if(typeof data96 !== "string"){
const err150 = {instancePath:instancePath+"/infrastructure/" + i0+"/install_status",schemaPath:"#/properties/infrastructure/items/anyOf/12/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[12].properties.install_status.type,parentSchema:schema12.properties.infrastructure.items.anyOf[12].properties.install_status,data:data96};
if(vErrors === null){
vErrors = [err150];
}
else {
vErrors.push(err150);
}
errors++;
}
}
if(data24.role_arn !== undefined){
let data97 = data24.role_arn;
if(typeof data97 !== "string"){
const err151 = {instancePath:instancePath+"/infrastructure/" + i0+"/role_arn",schemaPath:"#/properties/infrastructure/items/anyOf/12/properties/role_arn/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema12.properties.infrastructure.items.anyOf[12].properties.role_arn.type,parentSchema:schema12.properties.infrastructure.items.anyOf[12].properties.role_arn,data:data97};
if(vErrors === null){
vErrors = [err151];
}
else {
vErrors.push(err151);
}
errors++;
}
}
}
else {
const err152 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf/12/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.properties.infrastructure.items.anyOf[12].type,parentSchema:schema12.properties.infrastructure.items.anyOf[12],data:data24};
if(vErrors === null){
vErrors = [err152];
}
else {
vErrors.push(err152);
}
errors++;
}
var _valid0 = _errs204 === errors;
valid3 = valid3 || _valid0;
}
}
}
}
}
}
}
}
}
}
}
}
if(!valid3){
const err153 = {instancePath:instancePath+"/infrastructure/" + i0,schemaPath:"#/properties/infrastructure/items/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf",schema:schema12.properties.infrastructure.items.anyOf,parentSchema:schema12.properties.infrastructure.items,data:data24};
if(vErrors === null){
vErrors = [err153];
}
else {
vErrors.push(err153);
}
errors++;
}
else {
errors = _errs46;
if(vErrors !== null){
if(_errs46){
vErrors.length = _errs46;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err154 = {instancePath:instancePath+"/infrastructure",schemaPath:"#/properties/infrastructure/type",keyword:"type",params:{type: "array"},message:"must be array",schema:schema12.properties.infrastructure.type,parentSchema:schema12.properties.infrastructure,data:data23};
if(vErrors === null){
vErrors = [err154];
}
else {
vErrors.push(err154);
}
errors++;
}
}
}
else {
const err155 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.type,parentSchema:schema12,data};
if(vErrors === null){
vErrors = [err155];
}
else {
vErrors.push(err155);
}
errors++;
}
validate11.errors = vErrors;
return errors === 0;
}

exports["4220425f"] = validate12;
const schema13 = {"type":"object","properties":{"resource_type":{"type":"string","const":"Database","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"alias":{"type":"string","description":"An alternative name or CNAME for the database."}},"title":"Database","anyOf":[{"required":["resource_type"]},{"required":["name"]},{"required":["environment"]},{"required":["install_status"]},{"required":["alias"]}],"$id":"4220425f"};

function validate12(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="4220425f" */;
let vErrors = null;
let errors = 0;
const _errs1 = errors;
let valid0 = false;
const _errs2 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type === undefined){
const err0 = {instancePath,schemaPath:"#/anyOf/0/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema13.anyOf[0].required,parentSchema:schema13.anyOf[0],data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var _valid0 = _errs2 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/anyOf/1/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema13.anyOf[1].required,parentSchema:schema13.anyOf[1],data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs3 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.environment === undefined){
const err2 = {instancePath,schemaPath:"#/anyOf/2/required",keyword:"required",params:{missingProperty: "environment"},message:"must have required property '"+"environment"+"'",schema:schema13.anyOf[2].required,parentSchema:schema13.anyOf[2],data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs4 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.install_status === undefined){
const err3 = {instancePath,schemaPath:"#/anyOf/3/required",keyword:"required",params:{missingProperty: "install_status"},message:"must have required property '"+"install_status"+"'",schema:schema13.anyOf[3].required,parentSchema:schema13.anyOf[3],data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.alias === undefined){
const err4 = {instancePath,schemaPath:"#/anyOf/4/required",keyword:"required",params:{missingProperty: "alias"},message:"must have required property '"+"alias"+"'",schema:schema13.anyOf[4].required,parentSchema:schema13.anyOf[4],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
var _valid0 = _errs6 === errors;
valid0 = valid0 || _valid0;
}
}
}
}
if(!valid0){
const err5 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf",schema:schema13.anyOf,parentSchema:schema13,data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type !== undefined){
let data0 = data.resource_type;
if(typeof data0 !== "string"){
const err6 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema13.properties.resource_type.type,parentSchema:schema13.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if("Database" !== data0){
const err7 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/const",keyword:"const",params:{allowedValue: "Database"},message:"must be equal to constant",schema:"Database",parentSchema:schema13.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 !== "string"){
const err8 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema13.properties.name.type,parentSchema:schema13.properties.name,data:data1};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.environment !== undefined){
let data2 = data.environment;
if(typeof data2 !== "string"){
const err9 = {instancePath:instancePath+"/environment",schemaPath:"#/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema13.properties.environment.type,parentSchema:schema13.properties.environment,data:data2};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.install_status !== undefined){
let data3 = data.install_status;
if(typeof data3 !== "string"){
const err10 = {instancePath:instancePath+"/install_status",schemaPath:"#/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema13.properties.install_status.type,parentSchema:schema13.properties.install_status,data:data3};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.alias !== undefined){
let data4 = data.alias;
if(typeof data4 !== "string"){
const err11 = {instancePath:instancePath+"/alias",schemaPath:"#/properties/alias/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema13.properties.alias.type,parentSchema:schema13.properties.alias,data:data4};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema13.type,parentSchema:schema13,data};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
validate12.errors = vErrors;
return errors === 0;
}

exports["13676b6c"] = validate13;
const schema14 = {"type":"object","properties":{"resource_type":{"type":"string","const":"Server","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"host_name":{"type":"string","description":"The fully qualified domain name (FQDN) of the server."},"ip_address":{"type":"string","format":"ipv4","description":"The primary IPv4 address of the server."},"os_type":{"type":"string","description":"The operating system running on the server (e.g., 'Linux', 'Windows Server')."}},"title":"Server","anyOf":[{"required":["resource_type"]},{"required":["name"]},{"required":["environment"]},{"required":["install_status"]},{"required":["host_name"]},{"required":["ip_address"]},{"required":["os_type"]}],"$id":"13676b6c"};

function validate13(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="13676b6c" */;
let vErrors = null;
let errors = 0;
const _errs1 = errors;
let valid0 = false;
const _errs2 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type === undefined){
const err0 = {instancePath,schemaPath:"#/anyOf/0/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema14.anyOf[0].required,parentSchema:schema14.anyOf[0],data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var _valid0 = _errs2 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/anyOf/1/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema14.anyOf[1].required,parentSchema:schema14.anyOf[1],data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs3 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.environment === undefined){
const err2 = {instancePath,schemaPath:"#/anyOf/2/required",keyword:"required",params:{missingProperty: "environment"},message:"must have required property '"+"environment"+"'",schema:schema14.anyOf[2].required,parentSchema:schema14.anyOf[2],data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs4 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.install_status === undefined){
const err3 = {instancePath,schemaPath:"#/anyOf/3/required",keyword:"required",params:{missingProperty: "install_status"},message:"must have required property '"+"install_status"+"'",schema:schema14.anyOf[3].required,parentSchema:schema14.anyOf[3],data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.host_name === undefined){
const err4 = {instancePath,schemaPath:"#/anyOf/4/required",keyword:"required",params:{missingProperty: "host_name"},message:"must have required property '"+"host_name"+"'",schema:schema14.anyOf[4].required,parentSchema:schema14.anyOf[4],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
var _valid0 = _errs6 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs7 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.ip_address === undefined){
const err5 = {instancePath,schemaPath:"#/anyOf/5/required",keyword:"required",params:{missingProperty: "ip_address"},message:"must have required property '"+"ip_address"+"'",schema:schema14.anyOf[5].required,parentSchema:schema14.anyOf[5],data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
var _valid0 = _errs7 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs8 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.os_type === undefined){
const err6 = {instancePath,schemaPath:"#/anyOf/6/required",keyword:"required",params:{missingProperty: "os_type"},message:"must have required property '"+"os_type"+"'",schema:schema14.anyOf[6].required,parentSchema:schema14.anyOf[6],data};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
var _valid0 = _errs8 === errors;
valid0 = valid0 || _valid0;
}
}
}
}
}
}
if(!valid0){
const err7 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf",schema:schema14.anyOf,parentSchema:schema14,data};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type !== undefined){
let data0 = data.resource_type;
if(typeof data0 !== "string"){
const err8 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema14.properties.resource_type.type,parentSchema:schema14.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if("Server" !== data0){
const err9 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/const",keyword:"const",params:{allowedValue: "Server"},message:"must be equal to constant",schema:"Server",parentSchema:schema14.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 !== "string"){
const err10 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema14.properties.name.type,parentSchema:schema14.properties.name,data:data1};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.environment !== undefined){
let data2 = data.environment;
if(typeof data2 !== "string"){
const err11 = {instancePath:instancePath+"/environment",schemaPath:"#/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema14.properties.environment.type,parentSchema:schema14.properties.environment,data:data2};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.install_status !== undefined){
let data3 = data.install_status;
if(typeof data3 !== "string"){
const err12 = {instancePath:instancePath+"/install_status",schemaPath:"#/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema14.properties.install_status.type,parentSchema:schema14.properties.install_status,data:data3};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.host_name !== undefined){
let data4 = data.host_name;
if(typeof data4 !== "string"){
const err13 = {instancePath:instancePath+"/host_name",schemaPath:"#/properties/host_name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema14.properties.host_name.type,parentSchema:schema14.properties.host_name,data:data4};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.ip_address !== undefined){
let data5 = data.ip_address;
if(typeof data5 === "string"){
if(!(formats2.test(data5))){
const err14 = {instancePath:instancePath+"/ip_address",schemaPath:"#/properties/ip_address/format",keyword:"format",params:{format: "ipv4"},message:"must match format \""+"ipv4"+"\"",schema:"ipv4",parentSchema:schema14.properties.ip_address,data:data5};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/ip_address",schemaPath:"#/properties/ip_address/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema14.properties.ip_address.type,parentSchema:schema14.properties.ip_address,data:data5};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.os_type !== undefined){
let data6 = data.os_type;
if(typeof data6 !== "string"){
const err16 = {instancePath:instancePath+"/os_type",schemaPath:"#/properties/os_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema14.properties.os_type.type,parentSchema:schema14.properties.os_type,data:data6};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema14.type,parentSchema:schema14,data};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate13.errors = vErrors;
return errors === 0;
}

exports["-54189dce"] = validate14;
const schema15 = {"type":"object","properties":{"resource_type":{"type":"string","const":"LoadBalancer","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"dns_name":{"type":"string","description":"The public or internal DNS name of the load balancer."},"listener_port":{"type":"integer","description":"The port the load balancer is listening on."}},"title":"LoadBalancer","anyOf":[{"required":["resource_type"]},{"required":["name"]},{"required":["environment"]},{"required":["install_status"]},{"required":["dns_name"]},{"required":["listener_port"]}],"$id":"-54189dce"};

function validate14(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-54189dce" */;
let vErrors = null;
let errors = 0;
const _errs1 = errors;
let valid0 = false;
const _errs2 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type === undefined){
const err0 = {instancePath,schemaPath:"#/anyOf/0/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema15.anyOf[0].required,parentSchema:schema15.anyOf[0],data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var _valid0 = _errs2 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/anyOf/1/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema15.anyOf[1].required,parentSchema:schema15.anyOf[1],data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs3 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.environment === undefined){
const err2 = {instancePath,schemaPath:"#/anyOf/2/required",keyword:"required",params:{missingProperty: "environment"},message:"must have required property '"+"environment"+"'",schema:schema15.anyOf[2].required,parentSchema:schema15.anyOf[2],data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs4 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.install_status === undefined){
const err3 = {instancePath,schemaPath:"#/anyOf/3/required",keyword:"required",params:{missingProperty: "install_status"},message:"must have required property '"+"install_status"+"'",schema:schema15.anyOf[3].required,parentSchema:schema15.anyOf[3],data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.dns_name === undefined){
const err4 = {instancePath,schemaPath:"#/anyOf/4/required",keyword:"required",params:{missingProperty: "dns_name"},message:"must have required property '"+"dns_name"+"'",schema:schema15.anyOf[4].required,parentSchema:schema15.anyOf[4],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
var _valid0 = _errs6 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs7 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.listener_port === undefined){
const err5 = {instancePath,schemaPath:"#/anyOf/5/required",keyword:"required",params:{missingProperty: "listener_port"},message:"must have required property '"+"listener_port"+"'",schema:schema15.anyOf[5].required,parentSchema:schema15.anyOf[5],data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
var _valid0 = _errs7 === errors;
valid0 = valid0 || _valid0;
}
}
}
}
}
if(!valid0){
const err6 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf",schema:schema15.anyOf,parentSchema:schema15,data};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type !== undefined){
let data0 = data.resource_type;
if(typeof data0 !== "string"){
const err7 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema15.properties.resource_type.type,parentSchema:schema15.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if("LoadBalancer" !== data0){
const err8 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/const",keyword:"const",params:{allowedValue: "LoadBalancer"},message:"must be equal to constant",schema:"LoadBalancer",parentSchema:schema15.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 !== "string"){
const err9 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema15.properties.name.type,parentSchema:schema15.properties.name,data:data1};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.environment !== undefined){
let data2 = data.environment;
if(typeof data2 !== "string"){
const err10 = {instancePath:instancePath+"/environment",schemaPath:"#/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema15.properties.environment.type,parentSchema:schema15.properties.environment,data:data2};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.install_status !== undefined){
let data3 = data.install_status;
if(typeof data3 !== "string"){
const err11 = {instancePath:instancePath+"/install_status",schemaPath:"#/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema15.properties.install_status.type,parentSchema:schema15.properties.install_status,data:data3};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.dns_name !== undefined){
let data4 = data.dns_name;
if(typeof data4 !== "string"){
const err12 = {instancePath:instancePath+"/dns_name",schemaPath:"#/properties/dns_name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema15.properties.dns_name.type,parentSchema:schema15.properties.dns_name,data:data4};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.listener_port !== undefined){
let data5 = data.listener_port;
if(!((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5)))){
const err13 = {instancePath:instancePath+"/listener_port",schemaPath:"#/properties/listener_port/type",keyword:"type",params:{type: "integer"},message:"must be integer",schema:schema15.properties.listener_port.type,parentSchema:schema15.properties.listener_port,data:data5};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema15.type,parentSchema:schema15,data};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate14.errors = vErrors;
return errors === 0;
}

exports["-4741ba94"] = validate15;
const schema16 = {"type":"object","properties":{"resource_type":{"type":"string","const":"Compute","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"instance_type":{"type":"string","description":"The instance size or type (e.g., 't3.medium', 'Standard_D2s_v3')."},"image_id":{"type":"string","description":"The ID of the machine image or template used."}},"title":"Compute","anyOf":[{"required":["resource_type"]},{"required":["name"]},{"required":["environment"]},{"required":["install_status"]},{"required":["instance_type"]},{"required":["image_id"]}],"$id":"-4741ba94"};

function validate15(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-4741ba94" */;
let vErrors = null;
let errors = 0;
const _errs1 = errors;
let valid0 = false;
const _errs2 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type === undefined){
const err0 = {instancePath,schemaPath:"#/anyOf/0/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema16.anyOf[0].required,parentSchema:schema16.anyOf[0],data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var _valid0 = _errs2 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/anyOf/1/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema16.anyOf[1].required,parentSchema:schema16.anyOf[1],data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs3 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.environment === undefined){
const err2 = {instancePath,schemaPath:"#/anyOf/2/required",keyword:"required",params:{missingProperty: "environment"},message:"must have required property '"+"environment"+"'",schema:schema16.anyOf[2].required,parentSchema:schema16.anyOf[2],data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs4 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.install_status === undefined){
const err3 = {instancePath,schemaPath:"#/anyOf/3/required",keyword:"required",params:{missingProperty: "install_status"},message:"must have required property '"+"install_status"+"'",schema:schema16.anyOf[3].required,parentSchema:schema16.anyOf[3],data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.instance_type === undefined){
const err4 = {instancePath,schemaPath:"#/anyOf/4/required",keyword:"required",params:{missingProperty: "instance_type"},message:"must have required property '"+"instance_type"+"'",schema:schema16.anyOf[4].required,parentSchema:schema16.anyOf[4],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
var _valid0 = _errs6 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs7 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.image_id === undefined){
const err5 = {instancePath,schemaPath:"#/anyOf/5/required",keyword:"required",params:{missingProperty: "image_id"},message:"must have required property '"+"image_id"+"'",schema:schema16.anyOf[5].required,parentSchema:schema16.anyOf[5],data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
var _valid0 = _errs7 === errors;
valid0 = valid0 || _valid0;
}
}
}
}
}
if(!valid0){
const err6 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf",schema:schema16.anyOf,parentSchema:schema16,data};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type !== undefined){
let data0 = data.resource_type;
if(typeof data0 !== "string"){
const err7 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema16.properties.resource_type.type,parentSchema:schema16.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if("Compute" !== data0){
const err8 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/const",keyword:"const",params:{allowedValue: "Compute"},message:"must be equal to constant",schema:"Compute",parentSchema:schema16.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 !== "string"){
const err9 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema16.properties.name.type,parentSchema:schema16.properties.name,data:data1};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.environment !== undefined){
let data2 = data.environment;
if(typeof data2 !== "string"){
const err10 = {instancePath:instancePath+"/environment",schemaPath:"#/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema16.properties.environment.type,parentSchema:schema16.properties.environment,data:data2};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.install_status !== undefined){
let data3 = data.install_status;
if(typeof data3 !== "string"){
const err11 = {instancePath:instancePath+"/install_status",schemaPath:"#/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema16.properties.install_status.type,parentSchema:schema16.properties.install_status,data:data3};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.instance_type !== undefined){
let data4 = data.instance_type;
if(typeof data4 !== "string"){
const err12 = {instancePath:instancePath+"/instance_type",schemaPath:"#/properties/instance_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema16.properties.instance_type.type,parentSchema:schema16.properties.instance_type,data:data4};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.image_id !== undefined){
let data5 = data.image_id;
if(typeof data5 !== "string"){
const err13 = {instancePath:instancePath+"/image_id",schemaPath:"#/properties/image_id/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema16.properties.image_id.type,parentSchema:schema16.properties.image_id,data:data5};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema16.type,parentSchema:schema16,data};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate15.errors = vErrors;
return errors === 0;
}

exports["58730bd3"] = validate16;
const schema17 = {"type":"object","properties":{"resource_type":{"type":"string","const":"Storage","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"storage_type":{"type":"string","description":"The type of storage (e.g., 'SSD', 'HDD', 'Object Storage')."},"capacity_gb":{"type":"integer","description":"The total capacity of the storage volume in gigabytes."}},"title":"Storage","anyOf":[{"required":["resource_type"]},{"required":["name"]},{"required":["environment"]},{"required":["install_status"]},{"required":["storage_type"]},{"required":["capacity_gb"]}],"$id":"58730bd3"};

function validate16(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="58730bd3" */;
let vErrors = null;
let errors = 0;
const _errs1 = errors;
let valid0 = false;
const _errs2 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type === undefined){
const err0 = {instancePath,schemaPath:"#/anyOf/0/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema17.anyOf[0].required,parentSchema:schema17.anyOf[0],data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var _valid0 = _errs2 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/anyOf/1/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema17.anyOf[1].required,parentSchema:schema17.anyOf[1],data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs3 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.environment === undefined){
const err2 = {instancePath,schemaPath:"#/anyOf/2/required",keyword:"required",params:{missingProperty: "environment"},message:"must have required property '"+"environment"+"'",schema:schema17.anyOf[2].required,parentSchema:schema17.anyOf[2],data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs4 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.install_status === undefined){
const err3 = {instancePath,schemaPath:"#/anyOf/3/required",keyword:"required",params:{missingProperty: "install_status"},message:"must have required property '"+"install_status"+"'",schema:schema17.anyOf[3].required,parentSchema:schema17.anyOf[3],data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.storage_type === undefined){
const err4 = {instancePath,schemaPath:"#/anyOf/4/required",keyword:"required",params:{missingProperty: "storage_type"},message:"must have required property '"+"storage_type"+"'",schema:schema17.anyOf[4].required,parentSchema:schema17.anyOf[4],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
var _valid0 = _errs6 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs7 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.capacity_gb === undefined){
const err5 = {instancePath,schemaPath:"#/anyOf/5/required",keyword:"required",params:{missingProperty: "capacity_gb"},message:"must have required property '"+"capacity_gb"+"'",schema:schema17.anyOf[5].required,parentSchema:schema17.anyOf[5],data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
var _valid0 = _errs7 === errors;
valid0 = valid0 || _valid0;
}
}
}
}
}
if(!valid0){
const err6 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf",schema:schema17.anyOf,parentSchema:schema17,data};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type !== undefined){
let data0 = data.resource_type;
if(typeof data0 !== "string"){
const err7 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema17.properties.resource_type.type,parentSchema:schema17.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if("Storage" !== data0){
const err8 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/const",keyword:"const",params:{allowedValue: "Storage"},message:"must be equal to constant",schema:"Storage",parentSchema:schema17.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 !== "string"){
const err9 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema17.properties.name.type,parentSchema:schema17.properties.name,data:data1};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.environment !== undefined){
let data2 = data.environment;
if(typeof data2 !== "string"){
const err10 = {instancePath:instancePath+"/environment",schemaPath:"#/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema17.properties.environment.type,parentSchema:schema17.properties.environment,data:data2};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.install_status !== undefined){
let data3 = data.install_status;
if(typeof data3 !== "string"){
const err11 = {instancePath:instancePath+"/install_status",schemaPath:"#/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema17.properties.install_status.type,parentSchema:schema17.properties.install_status,data:data3};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.storage_type !== undefined){
let data4 = data.storage_type;
if(typeof data4 !== "string"){
const err12 = {instancePath:instancePath+"/storage_type",schemaPath:"#/properties/storage_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema17.properties.storage_type.type,parentSchema:schema17.properties.storage_type,data:data4};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.capacity_gb !== undefined){
let data5 = data.capacity_gb;
if(!((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5)))){
const err13 = {instancePath:instancePath+"/capacity_gb",schemaPath:"#/properties/capacity_gb/type",keyword:"type",params:{type: "integer"},message:"must be integer",schema:schema17.properties.capacity_gb.type,parentSchema:schema17.properties.capacity_gb,data:data5};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema17.type,parentSchema:schema17,data};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate16.errors = vErrors;
return errors === 0;
}

exports["-25748c4e"] = validate17;
const schema18 = {"type":"object","properties":{"resource_type":{"type":"string","const":"Middleware","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"middleware_type":{"type":"string","description":"The type of middleware (e.g., 'Message Broker', 'Application Server', 'Integration Platform')."},"vendor":{"type":"string","description":"The vendor or provider of the middleware (e.g., 'IBM', 'Oracle', 'Apache')."},"version":{"type":"string","description":"The version of the middleware."}},"title":"Middleware","anyOf":[{"required":["resource_type"]},{"required":["name"]},{"required":["environment"]},{"required":["install_status"]},{"required":["middleware_type"]},{"required":["vendor"]},{"required":["version"]}],"$id":"-25748c4e"};

function validate17(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-25748c4e" */;
let vErrors = null;
let errors = 0;
const _errs1 = errors;
let valid0 = false;
const _errs2 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type === undefined){
const err0 = {instancePath,schemaPath:"#/anyOf/0/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema18.anyOf[0].required,parentSchema:schema18.anyOf[0],data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var _valid0 = _errs2 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/anyOf/1/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema18.anyOf[1].required,parentSchema:schema18.anyOf[1],data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs3 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.environment === undefined){
const err2 = {instancePath,schemaPath:"#/anyOf/2/required",keyword:"required",params:{missingProperty: "environment"},message:"must have required property '"+"environment"+"'",schema:schema18.anyOf[2].required,parentSchema:schema18.anyOf[2],data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs4 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.install_status === undefined){
const err3 = {instancePath,schemaPath:"#/anyOf/3/required",keyword:"required",params:{missingProperty: "install_status"},message:"must have required property '"+"install_status"+"'",schema:schema18.anyOf[3].required,parentSchema:schema18.anyOf[3],data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.middleware_type === undefined){
const err4 = {instancePath,schemaPath:"#/anyOf/4/required",keyword:"required",params:{missingProperty: "middleware_type"},message:"must have required property '"+"middleware_type"+"'",schema:schema18.anyOf[4].required,parentSchema:schema18.anyOf[4],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
var _valid0 = _errs6 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs7 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.vendor === undefined){
const err5 = {instancePath,schemaPath:"#/anyOf/5/required",keyword:"required",params:{missingProperty: "vendor"},message:"must have required property '"+"vendor"+"'",schema:schema18.anyOf[5].required,parentSchema:schema18.anyOf[5],data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
var _valid0 = _errs7 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs8 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.version === undefined){
const err6 = {instancePath,schemaPath:"#/anyOf/6/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'",schema:schema18.anyOf[6].required,parentSchema:schema18.anyOf[6],data};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
var _valid0 = _errs8 === errors;
valid0 = valid0 || _valid0;
}
}
}
}
}
}
if(!valid0){
const err7 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf",schema:schema18.anyOf,parentSchema:schema18,data};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type !== undefined){
let data0 = data.resource_type;
if(typeof data0 !== "string"){
const err8 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema18.properties.resource_type.type,parentSchema:schema18.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if("Middleware" !== data0){
const err9 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/const",keyword:"const",params:{allowedValue: "Middleware"},message:"must be equal to constant",schema:"Middleware",parentSchema:schema18.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 !== "string"){
const err10 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema18.properties.name.type,parentSchema:schema18.properties.name,data:data1};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.environment !== undefined){
let data2 = data.environment;
if(typeof data2 !== "string"){
const err11 = {instancePath:instancePath+"/environment",schemaPath:"#/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema18.properties.environment.type,parentSchema:schema18.properties.environment,data:data2};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.install_status !== undefined){
let data3 = data.install_status;
if(typeof data3 !== "string"){
const err12 = {instancePath:instancePath+"/install_status",schemaPath:"#/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema18.properties.install_status.type,parentSchema:schema18.properties.install_status,data:data3};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.middleware_type !== undefined){
let data4 = data.middleware_type;
if(typeof data4 !== "string"){
const err13 = {instancePath:instancePath+"/middleware_type",schemaPath:"#/properties/middleware_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema18.properties.middleware_type.type,parentSchema:schema18.properties.middleware_type,data:data4};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.vendor !== undefined){
let data5 = data.vendor;
if(typeof data5 !== "string"){
const err14 = {instancePath:instancePath+"/vendor",schemaPath:"#/properties/vendor/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema18.properties.vendor.type,parentSchema:schema18.properties.vendor,data:data5};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.version !== undefined){
let data6 = data.version;
if(typeof data6 !== "string"){
const err15 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema18.properties.version.type,parentSchema:schema18.properties.version,data:data6};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema18.type,parentSchema:schema18,data};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate17.errors = vErrors;
return errors === 0;
}

exports["25c60f57"] = validate18;
const schema19 = {"type":"object","properties":{"resource_type":{"type":"string","const":"VPC","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"cidr_block":{"type":"string","description":"The CIDR block for the VPC (e.g., '10.0.0.0/16')."}},"title":"VPC","anyOf":[{"required":["resource_type"]},{"required":["name"]},{"required":["environment"]},{"required":["install_status"]},{"required":["cidr_block"]}],"$id":"25c60f57"};

function validate18(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="25c60f57" */;
let vErrors = null;
let errors = 0;
const _errs1 = errors;
let valid0 = false;
const _errs2 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type === undefined){
const err0 = {instancePath,schemaPath:"#/anyOf/0/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema19.anyOf[0].required,parentSchema:schema19.anyOf[0],data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var _valid0 = _errs2 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/anyOf/1/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema19.anyOf[1].required,parentSchema:schema19.anyOf[1],data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs3 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.environment === undefined){
const err2 = {instancePath,schemaPath:"#/anyOf/2/required",keyword:"required",params:{missingProperty: "environment"},message:"must have required property '"+"environment"+"'",schema:schema19.anyOf[2].required,parentSchema:schema19.anyOf[2],data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs4 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.install_status === undefined){
const err3 = {instancePath,schemaPath:"#/anyOf/3/required",keyword:"required",params:{missingProperty: "install_status"},message:"must have required property '"+"install_status"+"'",schema:schema19.anyOf[3].required,parentSchema:schema19.anyOf[3],data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.cidr_block === undefined){
const err4 = {instancePath,schemaPath:"#/anyOf/4/required",keyword:"required",params:{missingProperty: "cidr_block"},message:"must have required property '"+"cidr_block"+"'",schema:schema19.anyOf[4].required,parentSchema:schema19.anyOf[4],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
var _valid0 = _errs6 === errors;
valid0 = valid0 || _valid0;
}
}
}
}
if(!valid0){
const err5 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf",schema:schema19.anyOf,parentSchema:schema19,data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type !== undefined){
let data0 = data.resource_type;
if(typeof data0 !== "string"){
const err6 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema19.properties.resource_type.type,parentSchema:schema19.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if("VPC" !== data0){
const err7 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/const",keyword:"const",params:{allowedValue: "VPC"},message:"must be equal to constant",schema:"VPC",parentSchema:schema19.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 !== "string"){
const err8 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema19.properties.name.type,parentSchema:schema19.properties.name,data:data1};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.environment !== undefined){
let data2 = data.environment;
if(typeof data2 !== "string"){
const err9 = {instancePath:instancePath+"/environment",schemaPath:"#/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema19.properties.environment.type,parentSchema:schema19.properties.environment,data:data2};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.install_status !== undefined){
let data3 = data.install_status;
if(typeof data3 !== "string"){
const err10 = {instancePath:instancePath+"/install_status",schemaPath:"#/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema19.properties.install_status.type,parentSchema:schema19.properties.install_status,data:data3};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.cidr_block !== undefined){
let data4 = data.cidr_block;
if(typeof data4 !== "string"){
const err11 = {instancePath:instancePath+"/cidr_block",schemaPath:"#/properties/cidr_block/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema19.properties.cidr_block.type,parentSchema:schema19.properties.cidr_block,data:data4};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema19.type,parentSchema:schema19,data};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
validate18.errors = vErrors;
return errors === 0;
}

exports["572defbc"] = validate19;
const schema20 = {"type":"object","properties":{"resource_type":{"type":"string","const":"SecurityGroup","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"description":{"type":"string","description":"A summary of the security group's purpose."}},"title":"Security Group","anyOf":[{"required":["resource_type"]},{"required":["name"]},{"required":["environment"]},{"required":["install_status"]},{"required":["description"]}],"$id":"572defbc"};

function validate19(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="572defbc" */;
let vErrors = null;
let errors = 0;
const _errs1 = errors;
let valid0 = false;
const _errs2 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type === undefined){
const err0 = {instancePath,schemaPath:"#/anyOf/0/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema20.anyOf[0].required,parentSchema:schema20.anyOf[0],data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var _valid0 = _errs2 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/anyOf/1/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema20.anyOf[1].required,parentSchema:schema20.anyOf[1],data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs3 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.environment === undefined){
const err2 = {instancePath,schemaPath:"#/anyOf/2/required",keyword:"required",params:{missingProperty: "environment"},message:"must have required property '"+"environment"+"'",schema:schema20.anyOf[2].required,parentSchema:schema20.anyOf[2],data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs4 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.install_status === undefined){
const err3 = {instancePath,schemaPath:"#/anyOf/3/required",keyword:"required",params:{missingProperty: "install_status"},message:"must have required property '"+"install_status"+"'",schema:schema20.anyOf[3].required,parentSchema:schema20.anyOf[3],data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.description === undefined){
const err4 = {instancePath,schemaPath:"#/anyOf/4/required",keyword:"required",params:{missingProperty: "description"},message:"must have required property '"+"description"+"'",schema:schema20.anyOf[4].required,parentSchema:schema20.anyOf[4],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
var _valid0 = _errs6 === errors;
valid0 = valid0 || _valid0;
}
}
}
}
if(!valid0){
const err5 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf",schema:schema20.anyOf,parentSchema:schema20,data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type !== undefined){
let data0 = data.resource_type;
if(typeof data0 !== "string"){
const err6 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema20.properties.resource_type.type,parentSchema:schema20.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if("SecurityGroup" !== data0){
const err7 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/const",keyword:"const",params:{allowedValue: "SecurityGroup"},message:"must be equal to constant",schema:"SecurityGroup",parentSchema:schema20.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 !== "string"){
const err8 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema20.properties.name.type,parentSchema:schema20.properties.name,data:data1};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.environment !== undefined){
let data2 = data.environment;
if(typeof data2 !== "string"){
const err9 = {instancePath:instancePath+"/environment",schemaPath:"#/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema20.properties.environment.type,parentSchema:schema20.properties.environment,data:data2};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.install_status !== undefined){
let data3 = data.install_status;
if(typeof data3 !== "string"){
const err10 = {instancePath:instancePath+"/install_status",schemaPath:"#/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema20.properties.install_status.type,parentSchema:schema20.properties.install_status,data:data3};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.description !== undefined){
let data4 = data.description;
if(typeof data4 !== "string"){
const err11 = {instancePath:instancePath+"/description",schemaPath:"#/properties/description/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema20.properties.description.type,parentSchema:schema20.properties.description,data:data4};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema20.type,parentSchema:schema20,data};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
validate19.errors = vErrors;
return errors === 0;
}

exports["15c7d25a"] = validate20;
const schema21 = {"type":"object","properties":{"resource_type":{"type":"string","const":"APIGateway","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"endpoint_type":{"enum":["Regional","Edge-Optimized","Private"],"description":"The type of API endpoint."}},"title":"API Gateway","anyOf":[{"required":["resource_type"]},{"required":["name"]},{"required":["environment"]},{"required":["install_status"]},{"required":["endpoint_type"]}],"$id":"15c7d25a"};

function validate20(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="15c7d25a" */;
let vErrors = null;
let errors = 0;
const _errs1 = errors;
let valid0 = false;
const _errs2 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type === undefined){
const err0 = {instancePath,schemaPath:"#/anyOf/0/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema21.anyOf[0].required,parentSchema:schema21.anyOf[0],data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var _valid0 = _errs2 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/anyOf/1/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema21.anyOf[1].required,parentSchema:schema21.anyOf[1],data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs3 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.environment === undefined){
const err2 = {instancePath,schemaPath:"#/anyOf/2/required",keyword:"required",params:{missingProperty: "environment"},message:"must have required property '"+"environment"+"'",schema:schema21.anyOf[2].required,parentSchema:schema21.anyOf[2],data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs4 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.install_status === undefined){
const err3 = {instancePath,schemaPath:"#/anyOf/3/required",keyword:"required",params:{missingProperty: "install_status"},message:"must have required property '"+"install_status"+"'",schema:schema21.anyOf[3].required,parentSchema:schema21.anyOf[3],data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.endpoint_type === undefined){
const err4 = {instancePath,schemaPath:"#/anyOf/4/required",keyword:"required",params:{missingProperty: "endpoint_type"},message:"must have required property '"+"endpoint_type"+"'",schema:schema21.anyOf[4].required,parentSchema:schema21.anyOf[4],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
var _valid0 = _errs6 === errors;
valid0 = valid0 || _valid0;
}
}
}
}
if(!valid0){
const err5 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf",schema:schema21.anyOf,parentSchema:schema21,data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type !== undefined){
let data0 = data.resource_type;
if(typeof data0 !== "string"){
const err6 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema21.properties.resource_type.type,parentSchema:schema21.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if("APIGateway" !== data0){
const err7 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/const",keyword:"const",params:{allowedValue: "APIGateway"},message:"must be equal to constant",schema:"APIGateway",parentSchema:schema21.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 !== "string"){
const err8 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema21.properties.name.type,parentSchema:schema21.properties.name,data:data1};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.environment !== undefined){
let data2 = data.environment;
if(typeof data2 !== "string"){
const err9 = {instancePath:instancePath+"/environment",schemaPath:"#/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema21.properties.environment.type,parentSchema:schema21.properties.environment,data:data2};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.install_status !== undefined){
let data3 = data.install_status;
if(typeof data3 !== "string"){
const err10 = {instancePath:instancePath+"/install_status",schemaPath:"#/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema21.properties.install_status.type,parentSchema:schema21.properties.install_status,data:data3};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.endpoint_type !== undefined){
let data4 = data.endpoint_type;
if(!(((data4 === "Regional") || (data4 === "Edge-Optimized")) || (data4 === "Private"))){
const err11 = {instancePath:instancePath+"/endpoint_type",schemaPath:"#/properties/endpoint_type/enum",keyword:"enum",params:{allowedValues: schema21.properties.endpoint_type.enum},message:"must be equal to one of the allowed values",schema:schema21.properties.endpoint_type.enum,parentSchema:schema21.properties.endpoint_type,data:data4};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema21.type,parentSchema:schema21,data};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
validate20.errors = vErrors;
return errors === 0;
}

exports["7b4aa055"] = validate21;
const schema22 = {"type":"object","properties":{"resource_type":{"type":"string","const":"ContainerOrchestrator","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"orchestrator_type":{"enum":["Kubernetes","ECS","Swarm"],"description":"The container orchestration platform."}},"title":"Container Orchestrator","anyOf":[{"required":["resource_type"]},{"required":["name"]},{"required":["environment"]},{"required":["install_status"]},{"required":["orchestrator_type"]}],"$id":"7b4aa055"};

function validate21(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="7b4aa055" */;
let vErrors = null;
let errors = 0;
const _errs1 = errors;
let valid0 = false;
const _errs2 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type === undefined){
const err0 = {instancePath,schemaPath:"#/anyOf/0/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema22.anyOf[0].required,parentSchema:schema22.anyOf[0],data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var _valid0 = _errs2 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/anyOf/1/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema22.anyOf[1].required,parentSchema:schema22.anyOf[1],data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs3 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.environment === undefined){
const err2 = {instancePath,schemaPath:"#/anyOf/2/required",keyword:"required",params:{missingProperty: "environment"},message:"must have required property '"+"environment"+"'",schema:schema22.anyOf[2].required,parentSchema:schema22.anyOf[2],data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs4 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.install_status === undefined){
const err3 = {instancePath,schemaPath:"#/anyOf/3/required",keyword:"required",params:{missingProperty: "install_status"},message:"must have required property '"+"install_status"+"'",schema:schema22.anyOf[3].required,parentSchema:schema22.anyOf[3],data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.orchestrator_type === undefined){
const err4 = {instancePath,schemaPath:"#/anyOf/4/required",keyword:"required",params:{missingProperty: "orchestrator_type"},message:"must have required property '"+"orchestrator_type"+"'",schema:schema22.anyOf[4].required,parentSchema:schema22.anyOf[4],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
var _valid0 = _errs6 === errors;
valid0 = valid0 || _valid0;
}
}
}
}
if(!valid0){
const err5 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf",schema:schema22.anyOf,parentSchema:schema22,data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type !== undefined){
let data0 = data.resource_type;
if(typeof data0 !== "string"){
const err6 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema22.properties.resource_type.type,parentSchema:schema22.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if("ContainerOrchestrator" !== data0){
const err7 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/const",keyword:"const",params:{allowedValue: "ContainerOrchestrator"},message:"must be equal to constant",schema:"ContainerOrchestrator",parentSchema:schema22.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 !== "string"){
const err8 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema22.properties.name.type,parentSchema:schema22.properties.name,data:data1};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.environment !== undefined){
let data2 = data.environment;
if(typeof data2 !== "string"){
const err9 = {instancePath:instancePath+"/environment",schemaPath:"#/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema22.properties.environment.type,parentSchema:schema22.properties.environment,data:data2};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.install_status !== undefined){
let data3 = data.install_status;
if(typeof data3 !== "string"){
const err10 = {instancePath:instancePath+"/install_status",schemaPath:"#/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema22.properties.install_status.type,parentSchema:schema22.properties.install_status,data:data3};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.orchestrator_type !== undefined){
let data4 = data.orchestrator_type;
if(!(((data4 === "Kubernetes") || (data4 === "ECS")) || (data4 === "Swarm"))){
const err11 = {instancePath:instancePath+"/orchestrator_type",schemaPath:"#/properties/orchestrator_type/enum",keyword:"enum",params:{allowedValues: schema22.properties.orchestrator_type.enum},message:"must be equal to one of the allowed values",schema:schema22.properties.orchestrator_type.enum,parentSchema:schema22.properties.orchestrator_type,data:data4};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema22.type,parentSchema:schema22,data};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
validate21.errors = vErrors;
return errors === 0;
}

exports["7a4fc4df"] = validate22;
const schema23 = {"type":"object","properties":{"resource_type":{"type":"string","const":"MessageQueue","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"queue_type":{"enum":["Standard","FIFO"],"description":"The type of message queue."}},"title":"Message Queue","anyOf":[{"required":["resource_type"]},{"required":["name"]},{"required":["environment"]},{"required":["install_status"]},{"required":["queue_type"]}],"$id":"7a4fc4df"};

function validate22(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="7a4fc4df" */;
let vErrors = null;
let errors = 0;
const _errs1 = errors;
let valid0 = false;
const _errs2 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type === undefined){
const err0 = {instancePath,schemaPath:"#/anyOf/0/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema23.anyOf[0].required,parentSchema:schema23.anyOf[0],data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var _valid0 = _errs2 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/anyOf/1/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema23.anyOf[1].required,parentSchema:schema23.anyOf[1],data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs3 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.environment === undefined){
const err2 = {instancePath,schemaPath:"#/anyOf/2/required",keyword:"required",params:{missingProperty: "environment"},message:"must have required property '"+"environment"+"'",schema:schema23.anyOf[2].required,parentSchema:schema23.anyOf[2],data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs4 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.install_status === undefined){
const err3 = {instancePath,schemaPath:"#/anyOf/3/required",keyword:"required",params:{missingProperty: "install_status"},message:"must have required property '"+"install_status"+"'",schema:schema23.anyOf[3].required,parentSchema:schema23.anyOf[3],data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.queue_type === undefined){
const err4 = {instancePath,schemaPath:"#/anyOf/4/required",keyword:"required",params:{missingProperty: "queue_type"},message:"must have required property '"+"queue_type"+"'",schema:schema23.anyOf[4].required,parentSchema:schema23.anyOf[4],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
var _valid0 = _errs6 === errors;
valid0 = valid0 || _valid0;
}
}
}
}
if(!valid0){
const err5 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf",schema:schema23.anyOf,parentSchema:schema23,data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type !== undefined){
let data0 = data.resource_type;
if(typeof data0 !== "string"){
const err6 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema23.properties.resource_type.type,parentSchema:schema23.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if("MessageQueue" !== data0){
const err7 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/const",keyword:"const",params:{allowedValue: "MessageQueue"},message:"must be equal to constant",schema:"MessageQueue",parentSchema:schema23.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 !== "string"){
const err8 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema23.properties.name.type,parentSchema:schema23.properties.name,data:data1};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.environment !== undefined){
let data2 = data.environment;
if(typeof data2 !== "string"){
const err9 = {instancePath:instancePath+"/environment",schemaPath:"#/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema23.properties.environment.type,parentSchema:schema23.properties.environment,data:data2};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.install_status !== undefined){
let data3 = data.install_status;
if(typeof data3 !== "string"){
const err10 = {instancePath:instancePath+"/install_status",schemaPath:"#/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema23.properties.install_status.type,parentSchema:schema23.properties.install_status,data:data3};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.queue_type !== undefined){
let data4 = data.queue_type;
if(!((data4 === "Standard") || (data4 === "FIFO"))){
const err11 = {instancePath:instancePath+"/queue_type",schemaPath:"#/properties/queue_type/enum",keyword:"enum",params:{allowedValues: schema23.properties.queue_type.enum},message:"must be equal to one of the allowed values",schema:schema23.properties.queue_type.enum,parentSchema:schema23.properties.queue_type,data:data4};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema23.type,parentSchema:schema23,data};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
validate22.errors = vErrors;
return errors === 0;
}

exports["-2bb6eded"] = validate23;
const schema24 = {"type":"object","properties":{"resource_type":{"type":"string","const":"IAMRole","title":"Resource Type"},"name":{"type":"string","description":"A human-readable name for the resource (e.g., 'prod-db-01')."},"environment":{"type":"string","description":"The deployment environment (e.g., 'production', 'staging')."},"install_status":{"type":"string","description":"The current installation or operational status of the resource."},"role_arn":{"type":"string","description":"The Amazon Resource Name (ARN) of the IAM role."}},"title":"IAM Role","anyOf":[{"required":["resource_type"]},{"required":["name"]},{"required":["environment"]},{"required":["install_status"]},{"required":["role_arn"]}],"$id":"-2bb6eded"};

function validate23(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-2bb6eded" */;
let vErrors = null;
let errors = 0;
const _errs1 = errors;
let valid0 = false;
const _errs2 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type === undefined){
const err0 = {instancePath,schemaPath:"#/anyOf/0/required",keyword:"required",params:{missingProperty: "resource_type"},message:"must have required property '"+"resource_type"+"'",schema:schema24.anyOf[0].required,parentSchema:schema24.anyOf[0],data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var _valid0 = _errs2 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err1 = {instancePath,schemaPath:"#/anyOf/1/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'",schema:schema24.anyOf[1].required,parentSchema:schema24.anyOf[1],data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
var _valid0 = _errs3 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.environment === undefined){
const err2 = {instancePath,schemaPath:"#/anyOf/2/required",keyword:"required",params:{missingProperty: "environment"},message:"must have required property '"+"environment"+"'",schema:schema24.anyOf[2].required,parentSchema:schema24.anyOf[2],data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
var _valid0 = _errs4 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs5 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.install_status === undefined){
const err3 = {instancePath,schemaPath:"#/anyOf/3/required",keyword:"required",params:{missingProperty: "install_status"},message:"must have required property '"+"install_status"+"'",schema:schema24.anyOf[3].required,parentSchema:schema24.anyOf[3],data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
var _valid0 = _errs5 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.role_arn === undefined){
const err4 = {instancePath,schemaPath:"#/anyOf/4/required",keyword:"required",params:{missingProperty: "role_arn"},message:"must have required property '"+"role_arn"+"'",schema:schema24.anyOf[4].required,parentSchema:schema24.anyOf[4],data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
var _valid0 = _errs6 === errors;
valid0 = valid0 || _valid0;
}
}
}
}
if(!valid0){
const err5 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf",schema:schema24.anyOf,parentSchema:schema24,data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.resource_type !== undefined){
let data0 = data.resource_type;
if(typeof data0 !== "string"){
const err6 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema24.properties.resource_type.type,parentSchema:schema24.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if("IAMRole" !== data0){
const err7 = {instancePath:instancePath+"/resource_type",schemaPath:"#/properties/resource_type/const",keyword:"const",params:{allowedValue: "IAMRole"},message:"must be equal to constant",schema:"IAMRole",parentSchema:schema24.properties.resource_type,data:data0};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.name !== undefined){
let data1 = data.name;
if(typeof data1 !== "string"){
const err8 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema24.properties.name.type,parentSchema:schema24.properties.name,data:data1};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.environment !== undefined){
let data2 = data.environment;
if(typeof data2 !== "string"){
const err9 = {instancePath:instancePath+"/environment",schemaPath:"#/properties/environment/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema24.properties.environment.type,parentSchema:schema24.properties.environment,data:data2};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.install_status !== undefined){
let data3 = data.install_status;
if(typeof data3 !== "string"){
const err10 = {instancePath:instancePath+"/install_status",schemaPath:"#/properties/install_status/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema24.properties.install_status.type,parentSchema:schema24.properties.install_status,data:data3};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.role_arn !== undefined){
let data4 = data.role_arn;
if(typeof data4 !== "string"){
const err11 = {instancePath:instancePath+"/role_arn",schemaPath:"#/properties/role_arn/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema24.properties.role_arn.type,parentSchema:schema24.properties.role_arn,data:data4};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema24.type,parentSchema:schema24,data};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
validate23.errors = vErrors;
return errors === 0;
}
